{
  "account.account": "Profil et Sécurité",
  "account.accountDeleted": "Votre compte a été supprimé avec succès.",
  "account.accountDescription": "Nom, mot de passe, suppression du compte",
  "account.accountSection": "Compte",
  "account.changeEmail": "Changer d'e-mail",
  "account.changePassword": "Changer de mot de passe",
  "account.currentPassword": "Mot de passe actuel",
  "account.dangerZone": "Zone sensible",
  "account.deleteAccount": "Supprimer le compte",
  "account.deleteAccountConfirmation": "Êtes-vous sûr de vouloir supprimer votre compte ? Cette action est irréversible.",
  "account.deleteAccountDescription": "Cette action supprime votre compte et toutes vos informations. Il n'y a pas de retour en arrière.",
  "account.emailChange": "Changer d'adresse e-mail",
  "account.emailChangeConfirmation": "Confirmation du changement d'e-mail",
  "account.emailChangeFailure": "Le lien de changement d'e-mail est invalide ou a expiré.",
  "account.emailChangeIntro": "Saisissez votre nouvelle adresse e-mail et votre mot de passe actuel. Nous enverrons un lien à la nouvelle adresse : votre e-mail ne changera qu’une fois ce lien ouvert.",
  "account.emailChangeSuccess": "Votre e-mail a été changé avec succès pour {newEmail}.",
  "account.emailChangeSuccessNoAddress": "Votre adresse e-mail a bien été modifiée.",
  "account.emailChangeVerificationSent": "Un e-mail de vérification a été envoyé à votre nouvelle adresse e-mail. Veuillez vérifier votre boîte de réception et cliquer sur le lien pour confirmer le changement.",
  "account.manageAccount": "Gérer le compte",
  "account.newEmailAddress": "Nouvelle adresse e-mail",
  "account.newPassword": "Nouveau mot de passe",
  "account.newPasswordAgain": "Confirmer le nouveau mot de passe",
  "account.oldPassword": "Ancien mot de passe",
  "account.passwordChange": "Changement de mot de passe",
  "account.passwordChangeDescription": "Gardez votre compte en sécurité",
  "account.passwordUpdated": "Mot de passe mis à jour avec succès.",
  "account.profile": "Profil",
  "account.profileUpdated": "Profil mis à jour avec succès.",
  "account.signedInAs": "Connecté en tant que",
  "account.updateYourProfile": "Mettez à jour votre profil",
  "account.updateYourProfileDescription": "Nom et préférences d'affichage",
  "addons.accountOnHold": "La connexion de votre compte a expiré. Veuillez vous reconnecter pour reprendre les mises à jour.",
  "addons.accountOnHoldTitle": "Compte suspendu",
  "addons.ambientWeatherCreateAndRetrieveApiKey": "Créer et récupérer votre clé d'API depuis ce lien",
  "addons.ambientWeatherDescription": "Stations météo Ambient Weather (WS-5000, WS-2000, WS-2902C,...)",
  "addons.apiKey": "Clé d'API",
  "addons.applicationKey": "Clé d'application",
  "addons.availableServices": "Disponibles",
  "addons.cannotDisconnectLastAccount": "Impossible de déconnecter votre seule méthode de connexion. Veuillez d'abord ajouter une autre méthode de connexion.",
  "addons.connect": "Connecter",
  "addons.connected": "Connecté",
  "addons.connectedAccounts": "Comptes connectés",
  "addons.connectedAccountsDescription": "Apple, Google, Facebook",
  "addons.connectedAccountsLoading": "Chargement de vos comptes connectés…",
  "addons.connectedServices": "Services connectés",
  "addons.connectedSince": "Connecté depuis le {date}",
  "addons.connectionSection": "Connexion",
  "addons.connectionSuccess": "Compte {provider} connecté avec succès",
  "addons.davisApiSecret": "API Secret",
  "addons.davisApiV2Key": "Clé API V2",
  "addons.davisDescription": "Stations météo Davis (Vantage Vue, Vantage Pro2,...)",
  "addons.davisRetrieveApiKey": "Récupérer vos clés d'API V2 depuis ce lien",
  "addons.disconnect": "Déconnecter",
  "addons.disconnectConfirmation": "Êtes-vous sûr de vouloir déconnecter votre compte {provider} ?",
  "addons.disconnectEnergyConfirmation": "SmartMixin arrêtera de synchroniser Netatmo Energy et retirera vos domiciles de SmartMixin. Votre compte Netatmo et vos appareils ne sont pas affectés.",
  "addons.disconnectEnergyDescription": "Arrête la synchronisation et retire vos domiciles de SmartMixin.",
  "addons.disconnectionSuccess": "Compte {provider} déconnecté avec succès",
  "addons.disconnectProviderDescription": "Arrête la synchronisation et supprime les stations de ce service ainsi que leur historique.",
  "addons.disconnectServiceConfirmation": "SmartMixin arrêtera de synchroniser {provider} et supprimera les stations de ce service ainsi que tout leur historique. Votre compte {provider} lui-même n’est pas affecté.",
  "addons.disconnectServiceTitle": "Déconnecter {provider} ?",
  "addons.ecowittCreateAndRetrieveKeys": "Créer et récupérer votre clé d'API et votre clé d'application depuis ce lien",
  "addons.ecowittDescription": "Ecowitt fournit des stations météo professionnelles, des thermomètres intérieurs/extérieurs sans fil, des pluviomètres de hautes précisions, des capteurs de qualité de l'air et bien plus encore.",
  "addons.helpLink": "Comment connecter {provider}",
  "addons.integrationsSection": "Intégrations",
  "addons.myAcuriteAccountOnHold": "La connexion à votre compte est impossible. Veuillez saisir votre mot de passe pour reconnecter votre compte",
  "addons.myAcuriteDescription": "AcuRite est la marque de stations météorologiques n°1 en Amérique du Nord. En tant que leader en technologie de temps, de température et de météo, AcuRite vous fournit des informations détaillées sur votre environnement intérieur et extérieur afin que vous puissiez planifier votre journée en toute confiance.",
  "addons.netatmoEnergy": "Netatmo Energy",
  "addons.netatmoEnergyDescription": "Utilisez votre thermostat Netatmo pour changer la température de votre maison, depuis votre lit ou depuis l'autre bout du monde.",
  "addons.netatmoWeather": "Netatmo Weather",
  "addons.netatmoWeatherDescription": "Votre station météo personnelle à la maison",
  "addons.notConnected": "Non connecté",
  "addons.or": "ou",
  "addons.providerAccountDisconnected": "La connexion à votre service météo a expiré. Veuillez vous reconnecter pour reprendre les mises à jour.",
  "addons.reconnect": "Reconnecter",
  "addons.socialConnectionsIntro": "Liez vos comptes sociaux pour une connexion rapide. Vous pouvez connecter ou déconnecter des comptes à tout moment.",
  "addons.weatherflowAccessToken": "Jeton d'accès",
  "addons.weatherflowCreateToken": "Créer et récupérer votre token depuis ce lien",
  "addons.weatherflowTempestDescription": "Système météo Tempest avec anémomètre et pluviomètre intégrés",
  "addons.weatherServices": "Services météo",
  "addons.weatherServicesConnected": "{count, plural, =0 {Aucun service connecté} one {# service connecté} other {# services connectés}}",
  "addons.weatherServicesDescription": "Connectez Netatmo, Davis, Weatherflow, et plus",
  "addons.wundergroundApiKey": "Clé d'API",
  "addons.wundergroundDescription": "Weather Underground est une communauté mondiale de personnes connectant les données de capteurs environnementaux tels que les stations météorologiques et les moniteurs de qualité de l'air afin que nous puissions fournir les données riches et hyperlocales dont vous avez besoin pour alimenter vos passions.",
  "addons.wundergroundRemoveStationDescription": "La station quitte votre compte SmartMixin. Sauf si un autre compte SmartMixin l'a aussi ajoutée, la station et l'historique que SmartMixin a enregistré pour elle sont supprimés. Rien ne change sur Weather Underground.",
  "addons.wundergroundRemoveStationTitle": "Supprimer {station} ?",
  "addons.wundergroundRetrieveApiKey": "Récupérer votre clé d'API depuis ce lien",
  "addons.wundergroundStationId": "Identifiant de la station",
  "airQuality.adviceActivityGood": "Journée idéale pour les activités en extérieur",
  "airQuality.adviceActivityHazardous": "Évitez toute activité physique en extérieur",
  "airQuality.adviceActivityLabel": "Activité physique",
  "airQuality.adviceActivityModerate": "Bonne journée pour les activités en extérieur",
  "airQuality.adviceActivitySensitive": "Envisagez des activités en extérieur plus courtes et moins intenses",
  "airQuality.adviceActivityUnhealthy": "Réduisez les activités longues ou intenses et faites plus de pauses",
  "airQuality.adviceActivityVeryUnhealthy": "Évitez les activités longues ou intenses ; envisagez de les déplacer à l'intérieur",
  "airQuality.adviceGroupsGood": "Aucune précaution particulière",
  "airQuality.adviceGroupsHazardous": "Restez à l'intérieur et limitez votre activité",
  "airQuality.adviceGroupsLabel": "Groupes sensibles",
  "airQuality.adviceGroupsModerate": "Personnes inhabituellement sensibles : des activités plus courtes et moins intenses",
  "airQuality.adviceGroupsSensitive": "Faites des activités en extérieur plus courtes et moins intenses, et plus de pauses",
  "airQuality.adviceGroupsUnhealthy": "Évitez les activités longues ou intenses en extérieur ; envisagez de les déplacer à l'intérieur",
  "airQuality.adviceGroupsVeryUnhealthy": "Évitez toute activité physique en extérieur ; reportez-la ou déplacez-la à l'intérieur",
  "airQuality.adviceTimingLabel": "Quand sortir",
  "airQuality.adviceTimingMorning": "Préférez la matinée : l'ozone est plus bas",
  "airQuality.airQuality": "Qualité de l'air",
  "airQuality.airQualityIndex": "Indice de qualité de l'air",
  "airQuality.aqiForecast": "Prévisions de qualité de l'air",
  "airQuality.co2Fresh": "Frais",
  "airQuality.co2GettingStale": "Un peu confiné",
  "airQuality.co2Stale": "Confiné",
  "airQuality.dailyForecast": "Prévisions quotidiennes",
  "airQuality.dominantPollutant": "Polluant dominant",
  "airQuality.expectedPeak": "Pic attendu",
  "airQuality.good": "Bon",
  "airQuality.goodDescription": "La qualité de l'air est jugée satisfaisante, et la pollution de l'air pose peu ou pas de risque.",
  "airQuality.hazardous": "Dangereux",
  "airQuality.hazardousDescription": "Alerte de santé : tout le monde peut ressentir des effets de santé plus graves.",
  "airQuality.indoorAirQuality": "Qualité de l'air intérieur",
  "airQuality.moderate": "Modéré",
  "airQuality.moderateDescription": "La qualité de l'air est acceptable. Cependant, pour certains polluants, il peut y avoir un risque sur la santé pour un très petit nombre de personnes inhabituellement sensibles à la pollution atmosphérique.",
  "airQuality.noForecastForLocation": "Aucune prévision de qualité de l'air n'est disponible pour ce lieu.",
  "airQuality.now": "Maintenant",
  "airQuality.nowCastAqi": "NowCast AQI",
  "airQuality.pollutants": "Polluants",
  "airQuality.recommendations": "Recommandations",
  "airQuality.sensitiveUnhealthy": "Mauvais pour les groupes sensibles",
  "airQuality.sensitiveUnhealthyDescription": "Les membres des groupes sensibles peuvent ressentir des effets sur la santé. Le grand public ne devrait pas être affecté.",
  "airQuality.subIndex": "Sous-indice AQI",
  "airQuality.ugm3": "µg/m³",
  "airQuality.understandIndex": "Comprendre l'indice",
  "airQuality.unhealthy": "Mauvais",
  "airQuality.unhealthyDescription": "Tout le monde peut commencer à ressentir des effets sur la santé ; les membres des groupes sensibles peuvent ressentir des effets de santé plus graves.",
  "airQuality.veryUnhealthy": "Très mauvais",
  "airQuality.veryUnhealthyDescription": "Avertissements de santé de conditions d'urgence. Toute la population est plus susceptible d'être affectée.",
  "alerts.addAlert": "Ajouter une alerte",
  "alerts.addCondition": "Ajouter une condition",
  "alerts.alertAdded": "Alerte ajoutée avec succès",
  "alerts.alertAuthorizationNotice": "Les alertes ne fonctionnent que si vous autorisez SmartMixin à afficher les notifications",
  "alerts.alertDeleted": "Alerte supprimée avec succès",
  "alerts.alertName": "Nom de l'alerte",
  "alerts.alertWhen": "Je souhaite être alerté·e quand :",
  "alerts.aqiGreaterThan": "AQI supérieur à",
  "alerts.aqiGreaterThanThreshold": "AQI supérieur au seuil de {value}{unit}",
  "alerts.aqiLessThan": "AQI inférieur à",
  "alerts.aqiLessThanThreshold": "AQI inférieur au seuil de {value}{unit}",
  "alerts.atLeastOneCondition": "Vous devez ajouter au moins une condition",
  "alerts.co2GreaterThan": "CO2 supérieur à",
  "alerts.co2GreaterThanThreshold": "CO2 supérieur au seuil de {value}{unit}",
  "alerts.co2LessThan": "CO2 inférieur à",
  "alerts.co2LessThanThreshold": "CO2 inférieur au seuil de {value}{unit}",
  "alerts.conditions": "Conditions",
  "alerts.conditionsDroppedOnStationChange": "Conditions non prises en charge par cette station, retirées : {conditions}",
  "alerts.createAlert": "Créer l'alerte",
  "alerts.dailyPrecipitationGreaterThan": "Précipitations journalières supérieures à",
  "alerts.dailyPrecipitationGreaterThanThreshold": "Précipitations journalières supérieures au seuil de {value}{unit}",
  "alerts.deleteAlert": "Supprimer l'alerte",
  "alerts.editAlert": "Modifier l'alerte",
  "alerts.editCondition": "Modifier la condition",
  "alerts.gustSpeedGreaterThan": "Rafale supérieure à",
  "alerts.gustSpeedGreaterThanThreshold": "Rafale supérieure au seuil de {value}{unit}",
  "alerts.gustSpeedLessThan": "Rafale inférieure à",
  "alerts.gustSpeedLessThanThreshold": "Rafale inférieure au seuil de {value}{unit}",
  "alerts.heatIndexGreaterThan": "Indice de chaleur supérieur à",
  "alerts.heatIndexGreaterThanThreshold": "Indice de chaleur supérieur au seuil de {value}{unit}",
  "alerts.heatIndexLessThan": "Indice de chaleur inférieur à",
  "alerts.heatIndexLessThanThreshold": "Indice de chaleur inférieur au seuil de {value}{unit}",
  "alerts.humidexGreaterThan": "Humidex supérieur à",
  "alerts.humidexGreaterThanThreshold": "Humidex supérieur au seuil de {value}{unit}",
  "alerts.humidexLessThan": "Humidex inférieur à",
  "alerts.humidexLessThanThreshold": "Humidex inférieur au seuil de {value}{unit}",
  "alerts.humidityGreaterThan": "Humidité supérieure à",
  "alerts.humidityGreaterThanThreshold": "Humidité supérieure au seuil de {value}{unit}",
  "alerts.humidityLessThan": "Humidité inférieure à",
  "alerts.humidityLessThanThreshold": "Humidité inférieure au seuil de {value}{unit}",
  "alerts.inProgress": "En cours",
  "alerts.leafWetnessGreaterThan": "Humectation foliaire supérieure à",
  "alerts.leafWetnessGreaterThanThreshold": "Humectation foliaire supérieure au seuil de {value}{unit}",
  "alerts.leafWetnessLessThan": "Humectation foliaire inférieure à",
  "alerts.leafWetnessLessThanThreshold": "Humectation foliaire inférieure au seuil de {value}{unit}",
  "alerts.myAlerts": "Mes alertes",
  "alerts.noConfiguredAlert": "Vous n'avez pas encore d'alerte, ajoutez-en une",
  "alerts.noiseGreaterThan": "Bruit supérieur à",
  "alerts.noiseGreaterThanThreshold": "Bruit supérieur au seuil de {value}{unit}",
  "alerts.noiseLessThan": "Bruit inférieur à",
  "alerts.noiseLessThanThreshold": "Bruit inférieur au seuil de {value}{unit}",
  "alerts.noteOnConditions": "Notez que l'alerte est déclenchée lorsque toutes les conditions ci-dessous sont vérifiées",
  "alerts.noTriggerHistory": "Cette alerte ne s'est pas encore déclenchée.",
  "alerts.pm10GreaterThan": "PM 10 supérieur à",
  "alerts.pm10GreaterThanThreshold": "PM 10 supérieur au seuil de {value}{unit}",
  "alerts.pm10LessThan": "PM 10 inférieur à",
  "alerts.pm10LessThanThreshold": "PM 10 inférieur au seuil de {value}{unit}",
  "alerts.pm1GreaterThan": "PM 1 supérieur à",
  "alerts.pm1GreaterThanThreshold": "PM 1 supérieur au seuil de {value}{unit}",
  "alerts.pm1LessThan": "PM 1 inférieur à",
  "alerts.pm1LessThanThreshold": "PM 1 inférieur au seuil de {value}{unit}",
  "alerts.pm2p5GreaterThan": "PM 2.5 supérieur à",
  "alerts.pm2p5GreaterThanThreshold": "PM 2.5 supérieur au seuil de {value}{unit}",
  "alerts.pm2p5LessThan": "PM 2.5 inférieur à",
  "alerts.pm2p5LessThanThreshold": "PM 2.5 inférieur au seuil de {value}{unit}",
  "alerts.postStormSummary": "Résumé de l'épisode pluvieux",
  "alerts.postStormSynopsisHelper": "Vous recevrez une notification récapitulative à la fin de chaque épisode pluvieux.",
  "alerts.postStormSynopsisSoleCondition": "Un résumé de l'épisode pluvieux ne peut pas être combiné avec d'autres conditions.",
  "alerts.precipitationGreaterThan": "Précipitations horaires supérieures à",
  "alerts.precipitationGreaterThanThreshold": "Précipitations horaires supérieures au seuil de {value}{unit}",
  "alerts.pressureGreaterThan": "Pression supérieure à",
  "alerts.pressureGreaterThanThreshold": "Pression supérieure au seuil de {value}{unit}",
  "alerts.pressureLessThan": "Pression inférieure à",
  "alerts.pressureLessThanThreshold": "Pression inférieure au seuil de {value}{unit}",
  "alerts.rainRateGreaterThan": "Intensité de pluie supérieure à",
  "alerts.rainRateGreaterThanThreshold": "Intensité de pluie supérieure au seuil de {value}{unit}",
  "alerts.sensorNotReporting": "Ce capteur n'envoie pas de données pour le moment. L'alerte reprendra dès qu'il en enverra à nouveau.",
  "alerts.soilMoistureGreaterThan": "Humidité du sol supérieure à",
  "alerts.soilMoistureGreaterThanThreshold": "Humidité du sol supérieure au seuil de {value}{unit}",
  "alerts.soilMoistureLessThan": "Humidité du sol inférieure à",
  "alerts.soilMoistureLessThanThreshold": "Humidité du sol inférieure au seuil de {value}{unit}",
  "alerts.solarRadiationGreaterThan": "Rayonnement solaire supérieur à",
  "alerts.solarRadiationGreaterThanThreshold": "Rayonnement solaire supérieur au seuil de {value}{unit}",
  "alerts.solarRadiationLessThan": "Rayonnement solaire inférieur à",
  "alerts.solarRadiationLessThanThreshold": "Rayonnement solaire inférieur au seuil de {value}{unit}",
  "alerts.stationNoLongerReports": "Cette station n’envoie plus de données, cette alerte ne peut donc pas se déclencher.",
  "alerts.stormChartUnavailable": "L'historique de pluie de cet épisode pluvieux n'est pas disponible.",
  "alerts.stormDetail": "Résumé de l'épisode pluvieux",
  "alerts.stormDuration": "Durée",
  "alerts.stormEnd": "Fin",
  "alerts.stormPeakRate": "Intensité maximale de pluie",
  "alerts.stormStart": "Début",
  "alerts.stormTotal": "Pluie totale",
  "alerts.temperatureGreaterThan": "Température supérieure à",
  "alerts.temperatureGreaterThanThreshold": "Température supérieure au seuil de {value}{unit}",
  "alerts.temperatureLessThan": "Température inférieure à",
  "alerts.temperatureLessThanThreshold": "Température inférieure au seuil de {value}{unit}",
  "alerts.thresholdOutOfRange": "Doit être compris entre {min} et {max}",
  "alerts.thswGreaterThan": "THSW supérieur à",
  "alerts.thswGreaterThanThreshold": "THSW supérieur au seuil de {value}{unit}",
  "alerts.thswLessThan": "THSW inférieur à",
  "alerts.thswLessThanThreshold": "THSW inférieur au seuil de {value}{unit}",
  "alerts.thwGreaterThan": "THW supérieur à",
  "alerts.thwGreaterThanThreshold": "THW supérieur au seuil de {value}{unit}",
  "alerts.thwLessThan": "THW inférieur à",
  "alerts.thwLessThanThreshold": "THW inférieur au seuil de {value}{unit}",
  "alerts.triggerHistory": "Historique de l'alerte",
  "alerts.uvGreaterThan": "UV supérieur à",
  "alerts.uvGreaterThanThreshold": "UV supérieur au seuil de {value}{unit}",
  "alerts.uvLessThan": "UV inférieur à",
  "alerts.uvLessThanThreshold": "UV inférieur au seuil de {value}{unit}",
  "alerts.visibilityGreaterThanThreshold": "Visibilité supérieure au seuil de {value}{unit}",
  "alerts.visibilityLessThanThreshold": "Visibilité inférieure au seuil de {value}{unit}",
  "alerts.visiblityGreaterThan": "Visibilité supérieure à",
  "alerts.visiblityLessThan": "Visibilité inférieure à",
  "alerts.whichMeasure": "Pour quelle mesure souhaitez-vous être alerté·e ?",
  "alerts.whichModule": "Pour quel module souhaitez-vous être alerté·e ?",
  "alerts.whichSensor": "Pour quel capteur souhaitez-vous être alerté·e ?",
  "alerts.windChillGreaterThan": "Refroidissement éolien supérieur à",
  "alerts.windChillGreaterThanThreshold": "Refroidissement éolien supérieur au seuil de {value}{unit}",
  "alerts.windChillLessThan": "Refroidissement éolien inférieur à",
  "alerts.windChillLessThanThreshold": "Refroidissement éolien inférieur au seuil de {value}{unit}",
  "alerts.windSpeedGreaterThan": "Vent supérieur à",
  "alerts.windSpeedGreaterThanThreshold": "Vent supérieur au seuil de {value}{unit}",
  "alerts.windSpeedLessThan": "Vent inférieur à",
  "alerts.windSpeedLessThanThreshold": "Vent inférieur au seuil de {value}{unit}",
  "appUpdate.updateAvailable": "Mise à jour disponible",
  "appUpdate.updateAvailableOpenAppStore": "Touchez pour ouvrir l'App Store",
  "appUpdate.updateAvailableOpenGooglePlay": "Touchez pour ouvrir Google Play",
  "appUpdate.updateAvailableVersion": "Mise à jour disponible : v{version}",
  "appUpdate.upgradeRequiredAndroid": "Une mise à jour de votre application est requise, accédez à Google Play pour la mise à niveau.",
  "appUpdate.upgradeRequiredIos": "Une mise à jour de votre application est requise, accédez à l'App Store pour la mise à niveau.",
  "astral.aboveHorizonAllDay": "Toujours au-dessus de l’horizon",
  "astral.aboveTheHorizon": "au-dessus de l’horizon",
  "astral.apparentSize": "Diamètre apparent",
  "astral.apparentSizeAcross": "{size} de diamètre",
  "astral.astronomicalDawn": "Aube astronomique",
  "astral.astronomicalDusk": "Crépuscule astronomique",
  "astral.belowHorizonAllDay": "Sous l’horizon toute la journée",
  "astral.belowHorizonSince": "Sous l’horizon depuis {time}",
  "astral.belowHorizonSinceOn": "Sous l’horizon depuis {day} {time}",
  "astral.brightAllNight": "Lune brillante toute la nuit — jamais vraiment noir",
  "astral.brightestMoment": "Moment le plus clair",
  "astral.civilDawn": "Aube civile",
  "astral.civilDusk": "Crépuscule civil",
  "astral.darkSkyBetween": "Ciel noir {from} → {to}",
  "astral.darkSkyWindow": "Ciel noir {from} → {to} · {duration} sans Lune",
  "astral.dayLength": "Durée du jour",
  "astral.daylightThroughTheYear": "Durée du jour sur l’année",
  "astral.dayOfCycle": "jour {day} sur {total}",
  "astral.doesNotOccurToday": "N’a pas lieu aujourd’hui",
  "astral.domeHint": "Faites glisser pour parcourir la nuit",
  "astral.domeReadout": "{time} · {altitude} · {direction}",
  "astral.earliestSunrise": "Lever le plus précoce",
  "astral.earliestSunset": "Coucher le plus précoce",
  "astral.equinox": "Équinoxe",
  "astral.equinoxIn": "Équinoxe dans {days, plural, one {# jour} other {# jours}}",
  "astral.evening": "Soir",
  "astral.exactPhaseAt": "Exactement à {time}",
  "astral.firstQuarter": "Premier quartier",
  "astral.firstSunriseIn": "Premier lever dans {days, plural, one {# jour} other {# jours}}",
  "astral.firstSunsetIn": "Premier coucher dans {days, plural, one {# jour} other {# jours}}",
  "astral.fullMoon": "Pleine Lune",
  "astral.goldenHourBegins": "Début de l’heure dorée",
  "astral.goldenHourEnds": "Fin de l’heure dorée",
  "astral.highestPoint": "Point le plus haut",
  "astral.inDays": "dans {days, plural, one {# jour} other {# jours}}",
  "astral.lastQuarter": "Dernier quartier",
  "astral.latestSunrise": "Lever le plus tardif",
  "astral.latestSunset": "Coucher le plus tardif",
  "astral.litShort": "Éclair.",
  "astral.longestDay": "Jour le plus long",
  "astral.lowestPoint": "Point le plus bas",
  "astral.maxAltitudeShort": "Max",
  "astral.midday": "Milieu de journée",
  "astral.midnightSun": "Soleil de minuit",
  "astral.midnightSunPeriod": "Soleil de minuit",
  "astral.milestoneFootnotePolar": "Ici, le soleil ne se lève ni ne se couche pendant {days, plural, one {# jour} other {# jours}} par an — à la place des extrêmes habituels de lever et de coucher, la liste indique quand cela se produit.",
  "astral.milestoneFootnoteTemperate": "Le coucher le plus précoce et le lever le plus tardif ne tombent pas le jour le plus court — c’est l’équation du temps, pas le solstice, qui fixe ces deux dates.",
  "astral.moon": "Lune",
  "astral.moonAltitude": "Hauteur",
  "astral.moonDirection": "Azimut",
  "astral.moonDistance": "Distance",
  "astral.moonlessFor": "{duration} sans Lune",
  "astral.moonPhases": "Phases de la Lune",
  "astral.moonrise": "Lever de Lune",
  "astral.moonset": "Coucher de Lune",
  "astral.moonUpAllNight": "La Lune est levée toute la nuit",
  "astral.moonWashesOutNight": "La Lune est levée de {rise} à {set} et éclaire toute la nuit",
  "astral.morning": "Matin",
  "astral.nauticalDawn": "Aube nautique",
  "astral.nauticalDusk": "Crépuscule nautique",
  "astral.newMoon": "Nouvelle Lune",
  "astral.nextDay": "+1 jour",
  "astral.nextProperlyDarkNight": "Prochaine nuit vraiment noire",
  "astral.nextRise": "prochain lever à {time}",
  "astral.nextRiseOn": "prochain lever {day} à {time}",
  "astral.nextSevenNights": "Les sept prochaines nuits",
  "astral.nightDate": "Date",
  "astral.noAstronomicalDarknessTonight": "Pas de nuit astronomique cette nuit",
  "astral.noDarkNightAhead": "Aucune dans les deux prochaines semaines",
  "astral.noStationLocation": "Position inconnue",
  "astral.noStationLocationDescription": "Cette station n’a aucune position enregistrée : le soleil et la lune ne peuvent donc pas être calculés pour elle.",
  "astral.noSunriseToday": "Pas de lever aujourd’hui",
  "astral.nowAtBearing": "actuellement {altitude} · azimut {direction}",
  "astral.observing": "Observation",
  "astral.ofDaylightLeft": "de jour restant",
  "astral.overTheNextThreeWeeks": "sur les 3 prochaines semaines",
  "astral.percentLit": "{percent} éclairée",
  "astral.polarNight": "Nuit polaire",
  "astral.polarNightPeriod": "Nuit polaire",
  "astral.rightNow": "En ce moment",
  "astral.riseShort": "Lever",
  "astral.setShort": "Coucher",
  "astral.shortestDay": "Jour le plus court",
  "astral.solarNoon": "Midi solaire",
  "astral.solstice": "Solstice",
  "astral.sunBelowHorizon": "Soleil à {degrees}° sous l’horizon",
  "astral.sunEvents": "Événements solaires",
  "astral.sunNeverDarkEnough": "Le Soleil ne descend jamais à 18° sous l’horizon",
  "astral.sunNeverSets": "Le Soleil ne se couche pas",
  "astral.sunrise": "Lever du Soleil",
  "astral.sunriseAndSunset": "Lever et coucher du Soleil",
  "astral.sunriseAt": "Lever du soleil à {time}",
  "astral.sunset": "Coucher du Soleil",
  "astral.sunsetAt": "Coucher du soleil à {time}",
  "astral.thisYearAtNorth": "Cette année à {degrees}° N",
  "astral.thisYearAtSouth": "Cette année à {degrees}° S",
  "astral.tonight": "Cette nuit",
  "astral.twilightAllNight": "Crépuscule toute la nuit — jamais vraiment noir",
  "astral.upFor": "{duration} au-dessus de l’horizon",
  "astral.usableLight": "Lumière exploitable",
  "astral.vsAverage": "{percent} vs moyenne",
  "astral.vsYesterday": "vs hier",
  "astral.waningCrescent": "Dernier croissant",
  "astral.waningGibbous": "Lune gibbeuse décroissante",
  "astral.waxingCrescent": "Premier croissant",
  "astral.waxingGibbous": "Lune gibbeuse croissante",
  "astral.whereToLook": "Où regarder",
  "astral.withoutTheMoon": "{duration} sans Lune",
  "auth.alreadyHaveAccount": "Vous avez déjà un compte ?",
  "auth.authContainerTagline": "Votre tableau de bord météo personnel. Connectez vos stations et accédez à vos données en temps réel.",
  "auth.backToLogin": "Retour à la connexion",
  "auth.checkYourEmail": "Vérifiez votre e-mail",
  "auth.continueWithApple": "Continuer avec Apple",
  "auth.continueWithFacebook": "Continuer avec Facebook",
  "auth.continueWithGoogle": "Continuer avec Google",
  "auth.email": "Adresse e-mail",
  "auth.emailRequiredLoginFacebook": "La permission e-mail est nécessaire pour se connecter avec Facebook",
  "auth.emailVerification": "Vérification de l'e-mail",
  "auth.emailVerificationFailure": "Nous avons rencontré un problème lors de la vérification de votre email.",
  "auth.emailVerificationSuccess": "Votre e-mail a été vérifié avec succès.",
  "auth.firstName": "Prénom",
  "auth.forgotPassword": "Mot de passe oublié",
  "auth.forgotPasswordSubtitle": "Entrez votre e-mail et nous vous enverrons un lien pour réinitialiser votre mot de passe.",
  "auth.lastName": "Nom",
  "auth.login": "Se connecter",
  "auth.loginSubtitle": "Content de vous revoir ! Veuillez entrer vos identifiants.",
  "auth.loginToSmartMixinDescription": "Connectez-vous à SmartMixin pour accéder à vos stations météo, consulter vos analyses et gérer votre tableau de bord météo personnel.",
  "auth.logout": "Se déconnecter",
  "auth.logoutConfirmation": "Voulez-vous vous déconnecter ?",
  "auth.noAccountYet": "Vous n'avez pas encore de compte ?",
  "auth.or": "ou",
  "auth.password": "Mot de passe",
  "auth.passwordReset": "Réinitialisation du mot de passe",
  "auth.passwordResetSuccess": "Mot de passe réinitialisé avec succès.",
  "auth.register": "Inscription",
  "auth.registerDescription": "Créez un compte SmartMixin gratuit pour connecter vos stations météo, suivre les données météorologiques et accéder à de puissants outils d’analyse.",
  "auth.registerSubtitle": "Créez votre compte pour commencer.",
  "auth.restorePassword": "Restaurer le mot de passe",
  "auth.restorePasswordSuccess": "Nous venons de vous envoyer un lien de réinitialisation de mot de passe à l'adresse {emailAddress} avec des instructions supplémentaires.",
  "auth.sendReset": "Envoyer les instructions de réinitialisation",
  "auth.signInWithApple": "Se connecter avec Apple",
  "auth.socialAccount": "ou utilisez votre compte",
  "auth.staffVerificationCode": "Code de vérification",
  "auth.staffVerificationExpiresIn": "Vérifié. Expire dans {duration}.",
  "auth.staffVerificationInvalidCode": "Code incorrect. Veuillez réessayer.",
  "auth.staffVerificationLoginAsStopped": "Login As a été arrêté : saisissez un code de vérification sur l'écran Debug pour continuer.",
  "auth.staffVerificationNotEnrolled": "Aucune application d'authentification n'est configurée pour votre compte. Ajoutez-en une dans les paramètres de sécurité du back-office.",
  "auth.staffVerificationPasskey": "Vérifier avec une clé d'accès",
  "auth.staffVerificationPasskeyExpired": "La demande de clé d'accès a expiré. Veuillez réessayer.",
  "auth.staffVerificationPasskeyFailed": "La vérification par clé d'accès a échoué. Veuillez réessayer ou saisir un code.",
  "auth.staffVerificationPasskeyNotEnrolled": "Aucune clé d'accès de votre compte n'est disponible sur ce téléphone. Ajoutez-en une depuis ce téléphone dans les paramètres de sécurité du back-office, ou saisissez un code.",
  "auth.staffVerificationPasskeySetupLink": "Ajouter une clé d'accès",
  "auth.staffVerificationPasskeyUnavailable": "Les clés d'accès ne peuvent pas être utilisées ici. Saisissez plutôt un code.",
  "auth.staffVerificationPrompt": "Saisissez le code à 6 chiffres de votre application d'authentification, ou un code de récupération, pour utiliser Login As et la recherche d'utilisateurs.",
  "auth.staffVerificationPromptPasskey": "Utilisez votre clé d'accès, ou saisissez le code à 6 chiffres de votre application d'authentification ou un code de récupération, pour utiliser Login As et la recherche d'utilisateurs.",
  "auth.staffVerificationSetupLink": "Ajouter une application d'authentification",
  "auth.staffVerificationSubmit": "Vérifier",
  "auth.staffVerificationTitle": "Vérification du personnel",
  "calendar.afternoon": "Après-midi",
  "calendar.april": "Avril",
  "calendar.august": "Août",
  "calendar.changePeriod": "Période : {period}. Changer de période",
  "calendar.currentDay": "Aujourd'hui",
  "calendar.dateFormat": "Format de date",
  "calendar.day": "Jour",
  "calendar.december": "Décembre",
  "calendar.durationHours": "{hours}h",
  "calendar.durationHoursMinutes": "{hours}h{minutes, number, ::integer-width/*00}",
  "calendar.durationMinutes": "{minutes} min",
  "calendar.durationMinutesSeconds": "{minutes} min {seconds} s",
  "calendar.durationSeconds": "{seconds} s",
  "calendar.earlierYears": "Années précédentes",
  "calendar.endTime": "Fin",
  "calendar.evening": "Soirée",
  "calendar.february": "Février",
  "calendar.goToNextDay": "Jour suivant",
  "calendar.goToNextMonth": "Mois suivant",
  "calendar.goToNextWeek": "Semaine suivante",
  "calendar.goToNextYear": "Année suivante",
  "calendar.goToPreviousDay": "Jour précédent",
  "calendar.goToPreviousMonth": "Mois précédent",
  "calendar.goToPreviousWeek": "Semaine précédente",
  "calendar.goToPreviousYear": "Année précédente",
  "calendar.hour": "Heure",
  "calendar.hoursCount": "{count, plural, one {# heure} other {# heures}}",
  "calendar.hoursShort": "h",
  "calendar.hoursShortCount": "{count, plural, one {# h} other {# h}}",
  "calendar.january": "Janvier",
  "calendar.july": "Juillet",
  "calendar.june": "Juin",
  "calendar.last12Hours": "12 dernières heures",
  "calendar.last24Hours": "24 dernières heures",
  "calendar.last30Days": "30 derniers jours",
  "calendar.last3Hours": "3 dernières heures",
  "calendar.last6Hours": "6 dernières heures",
  "calendar.last7Days": "7 derniers jours",
  "calendar.lastHour": "Dernière heure",
  "calendar.laterYears": "Années suivantes",
  "calendar.march": "Mars",
  "calendar.max": "Max",
  "calendar.may": "Mai",
  "calendar.month": "Mois",
  "calendar.monthTotal": "Ce mois-ci",
  "calendar.morning": "Matin",
  "calendar.nextHours": "Heures à venir",
  "calendar.night": "Nuit",
  "calendar.november": "Novembre",
  "calendar.october": "Octobre",
  "calendar.oneDay": "1 jour",
  "calendar.oneHour": "1 heure",
  "calendar.oneMonth": "1 mois",
  "calendar.oneWeek": "1 semaine",
  "calendar.periodRangeSpoken": "du {start} au {end}",
  "calendar.previous24Hours": "Les 24 heures précédentes",
  "calendar.previous30Days": "Les 30 jours précédents",
  "calendar.previous7Days": "Les 7 jours précédents",
  "calendar.previousDay": "Jour précédent",
  "calendar.previousHours": "Heures précédentes",
  "calendar.previousMonth": "Mois précédent",
  "calendar.previousWeek": "Semaine précédente",
  "calendar.previousYear": "Année précédente",
  "calendar.sameDayLastYear": "Même jour l'année dernière",
  "calendar.sameMonthLastYear": "Même mois l'année dernière",
  "calendar.selectADate": "Sélectionnez une date",
  "calendar.selectAggregation": "Choisir la valeur affichée",
  "calendar.selectAMonth": "Sélectionnez un mois",
  "calendar.selectAYear": "Sélectionnez une année",
  "calendar.selectGranularity": "Granularité des mesures",
  "calendar.selectPeriod": "Sélectionnez une période",
  "calendar.september": "Septembre",
  "calendar.sixHours": "6 heures",
  "calendar.startTime": "Début",
  "calendar.thirtyMinutes": "30 min",
  "calendar.threeHours": "3 heures",
  "calendar.timezone": "Fuseau horaire",
  "calendar.today": "Aujourd'hui",
  "calendar.untilChanged": "Jusqu'à nouvel ordre",
  "calendar.untilTime": "Jusqu'à {time}",
  "calendar.untilTodayAt": "Jusqu’à {time} aujourd’hui",
  "calendar.untilTomorrowAt": "Jusqu’à demain à {time}",
  "calendar.use24HourFormat": "Utiliser le format 24h",
  "calendar.week": "Semaine",
  "calendar.year": "Année",
  "calendar.yearToDate": "Cette année",
  "calendar.yesterday": "Hier",
  "charts.averageOverThePeriod": "Moyenne sur la période",
  "charts.calendarView": "Vue du calendrier",
  "charts.charts": "Graphiques",
  "charts.chartView": "Vue graphique",
  "charts.comparison": "Comparaison",
  "charts.customizeComparisonMetrics": "Personnaliser les métriques",
  "charts.customizeComparisonMetricsDescription": "Faites glisser les éléments pour réorganiser vos métriques de comparaison. Appuyez sur l'icône œil pour afficher ou masquer des métriques.",
  "charts.loading": "Chargement du graphique",
  "charts.maxOverThePeriod": "Maximum sur la période",
  "charts.measureToDisplay": "Mesure à afficher",
  "charts.minMaxRange": "Min. / Max.",
  "charts.noDataForThisPeriod": "Pas de données pour cette période",
  "charts.observations": "Observations",
  "charts.observedTemperature": "Température observée",
  "charts.seriesTableDate": "Date",
  "charts.showComparison": "Afficher la comparaison",
  "charts.stationComparison": "Comparaison de stations",
  "charts.stationComparisonDescription": "Permet de comparer les données météo historiques avec celles d'une autre station.",
  "charts.sumOverThePeriod": "Cumulé sur la période",
  "charts.tableLabel": "Tableau : {chart}",
  "charts.toggleSeries": "Afficher ou masquer {series}",
  "charts.viewAsChart": "Graphique",
  "charts.viewAsList": "Liste",
  "charts.viewAsPeriods": "Moments",
  "charts.viewAsTable": "Tableau",
  "charts.viewLabel": "Affichage : {chart}",
  "common.add": "Ajouter",
  "common.altitude": "Altitude",
  "common.analysis": "Analyses",
  "common.average": "Moyenne",
  "common.back": "Retour",
  "common.backToHome": "Retour à l'accueil",
  "common.cancel": "Annuler",
  "common.cannotBeEmpty": "Ce champ ne peut pas être vide.",
  "common.close": "Fermer",
  "common.dailyForecast": "Prévisions quotidiennes",
  "common.default": "Par défaut",
  "common.delete": "Supprimer",
  "common.details": "Détails",
  "common.edit": "Modifier",
  "common.exitFullscreen": "Quitter le plein écran",
  "common.forecast": "Prévisions",
  "common.frequency": "Fréquence",
  "common.full": "Plein",
  "common.fullscreen": "Plein écran",
  "common.help": "Aide",
  "common.hidden": "Masqués",
  "common.high": "Élevé",
  "common.iDontKnowYet": "Je ne sais pas encore",
  "common.indoor": "Intérieur",
  "common.labelValue": "{label} : {value}",
  "common.lastUpdate": "Dernière mise à jour",
  "common.low": "Faible",
  "common.maximum": "Maximum",
  "common.medium": "Moyen",
  "common.minimum": "Minimum",
  "common.more": "Plus",
  "common.moreInformation": "Plus d'informations",
  "common.next": "Suivant",
  "common.no": "Non",
  "common.noAccountNeeded": "Aucun compte requis",
  "common.noItemsAvailable": "Aucun élément disponible",
  "common.notNow": "Pas maintenant",
  "common.now": "Maintenant",
  "common.openSettings": "Paramètres",
  "common.outdoor": "Extérieur",
  "common.pageNotFound": "Page non trouvée",
  "common.pageNotFoundDescription": "La page que vous recherchez n'existe pas ou a été déplacée.",
  "common.rain": "Pluie",
  "common.reorderCancel": "Déplacement annulé : {item}. De retour en position {position} sur {count}.",
  "common.reorderEnd": "Élément déposé : {item}. Position {position} sur {count}.",
  "common.reorderInstructions": "Pour déplacer cet élément, appuyez sur Espace ou Entrée, choisissez sa place avec les flèches haut et bas, puis appuyez de nouveau sur Espace ou Entrée pour le déposer, ou sur Échap pour annuler.",
  "common.reorderOver": "{item} : maintenant en position {position} sur {count}.",
  "common.reorderStart": "Élément saisi : {item}. Position {position} sur {count}.",
  "common.share": "Partager",
  "common.shareImageFailed": "Impossible de partager l'image",
  "common.shareYourWeather": "Partagez votre météo",
  "common.skip": "Passer",
  "common.start": "Commencer",
  "common.unknown": "Inconnu",
  "common.validate": "Valider",
  "common.validEmail": "Une adresse e-mail valide est requise.",
  "common.very_low": "Très faible",
  "common.weatherObservations": "Observations météo",
  "common.welcome": "Bienvenue sur SmartMixin !",
  "common.wind": "Vent",
  "common.yes": "Oui",
  "common.zoomImage": "Agrandir l'image",
  "compass.E": "E",
  "compass.E_long": "est",
  "compass.ENE": "ENE",
  "compass.ENE_long": "est-nord-est",
  "compass.ESE": "ESE",
  "compass.ESE_long": "est-sud-est",
  "compass.N": "N",
  "compass.N_long": "nord",
  "compass.NE": "NE",
  "compass.NE_long": "nord-est",
  "compass.NNE": "NNE",
  "compass.NNE_long": "nord-nord-est",
  "compass.NNW": "NNO",
  "compass.NNW_long": "nord-nord-ouest",
  "compass.NW": "NO",
  "compass.NW_long": "nord-ouest",
  "compass.S": "S",
  "compass.S_long": "sud",
  "compass.SE": "SE",
  "compass.SE_long": "sud-est",
  "compass.SSE": "SSE",
  "compass.SSE_long": "sud-sud-est",
  "compass.SSW": "SSO",
  "compass.SSW_long": "sud-sud-ouest",
  "compass.SW": "SO",
  "compass.SW_long": "sud-ouest",
  "compass.W": "O",
  "compass.W_long": "ouest",
  "compass.WNW": "ONO",
  "compass.WNW_long": "ouest-nord-ouest",
  "compass.WSW": "OSO",
  "compass.WSW_long": "ouest-sud-ouest",
  "dashboard.currentObservations": "Dernières observations",
  "dashboard.currentRainEvent": "Événement pluvieux actuel",
  "dashboard.currentWeatherConditions": "Conditions actuelles",
  "dashboard.customizeDashboard": "Personnaliser",
  "dashboard.customizeDashboardDescription": "Faites glisser les éléments pour réorganiser votre tableau de bord. Appuyez sur l'icône œil pour afficher ou masquer des sections.",
  "dashboard.dashboard": "Synthèse",
  "dashboard.dayRangeExpected": "{value} attendu à {time}",
  "dashboard.dayRangeReached": "{value} à {time}",
  "dashboard.dayRangeSteady": "Stable à {value} toute la journée",
  "dashboard.hiddenSensors": "Capteurs masqués",
  "dashboard.hideSensor": "Masquer {sensor}",
  "dashboard.lastRainEvent": "Dernier événement pluvieux",
  "dashboard.lastVisibleSensor": "Au moins un capteur doit rester visible.",
  "dashboard.manageSensors": "Gérer les capteurs",
  "dashboard.manageSensorsDescription": "Faites glisser les éléments pour réorganiser les capteurs. Appuyez sur l'icône œil pour afficher ou masquer des capteurs. Appuyez sur un nom pour le renommer.",
  "dashboard.manageSensorsDescriptionWeb": "Cliquez sur le crayon pour renommer un capteur, faites glisser sa poignée pour réorganiser la liste, et cliquez sur l'œil pour le masquer ou l'afficher.",
  "dashboard.moveSensor": "Déplacer {sensor}",
  "dashboard.pressureSummary": "Synthèse de la pression",
  "dashboard.rainEvents": "Événements pluvieux",
  "dashboard.rainSummary": "Synthèse des précipitations",
  "dashboard.renameSensor": "Renommer {sensor}",
  "dashboard.shareOutdoorMeasures": "Partagez vos mesures extérieures",
  "dashboard.shareOutdoorMeasuresDescription": "Participez à la communauté SmartMixin en partageant vos données extérieures. Les données des modules intérieurs ne seront jamais partagées.",
  "dashboard.showSensor": "Afficher {sensor}",
  "dashboard.temperatureSummary": "Synthèse de la température",
  "dashboard.useDefaultSensorName": "Utiliser le nom par défaut",
  "dashboard.windSummary": "Synthèse du vent",
  "devices.batteryLevel": "Niveau de batterie",
  "devices.firmwareVersion": "Version du micrologiciel",
  "devices.moduleCount": "{count, plural, one {# module} other {# modules}}",
  "devices.moduleType": "Type de module",
  "devices.noNetatmoWeatherStationYet": "Vous n'avez pas encore de station météo Netatmo.",
  "devices.noOutdoorModule": "Il n'y a pas de module extérieur fonctionnel pour cette station.",
  "devices.notReachable": "Injoignable",
  "devices.serialNumber": "Numéro de série",
  "devices.signalAverage": "Moyen",
  "devices.signalBad": "Faible",
  "devices.signalGood": "Bon",
  "devices.signalStrength": "Force du signal",
  "devices.signalUnknown": "Inconnu",
  "devices.visitNetatmoWebsite": "Site web Netatmo",
  "devices.wifiStrength": "Force Wi-Fi",
  "forecastMaps.addColor": "Ajouter une couleur",
  "forecastMaps.addLayer": "Ajouter une couche",
  "forecastMaps.autoDescription": "Le meilleur pour cette vue",
  "forecastMaps.autoDescriptionFree": "Les comptes gratuits utilisent {model}",
  "forecastMaps.autoPreview": "Auto",
  "forecastMaps.autoSwitched": "{model} affiché : {previous} couvre {coverage, number, percent} de cette vue",
  "forecastMaps.backToMaps": "Retour aux cartes",
  "forecastMaps.build": "Générer",
  "forecastMaps.buildCompleted": "Génération terminée",
  "forecastMaps.builderMetaDescription": "Composez des cartes de prévision personnalisées à partir des couches des modèles météo.",
  "forecastMaps.builderTitle": "Créateur de cartes",
  "forecastMaps.buildFailed": "La génération a échoué. Veuillez réessayer.",
  "forecastMaps.buildNotPossible": "Cette carte ne peut pas encore être générée — aucune donnée de prévision n'est disponible.",
  "forecastMaps.buildProgress": "Rendu… {completed}/{total} étapes",
  "forecastMaps.buildStarting": "Démarrage de la génération…",
  "forecastMaps.byModel": "Par modèle",
  "forecastMaps.byZone": "Par zone",
  "forecastMaps.colormap": "Palette de couleurs",
  "forecastMaps.colormapCustom": "Couleurs personnalisées",
  "forecastMaps.colormapGroupDomain": "Palettes météo",
  "forecastMaps.colormapGroupMatplotlib": "Palettes scientifiques",
  "forecastMaps.colorStop": "Couleur {position}",
  "forecastMaps.configUnavailable": "Cette carte de prévision n’est pas disponible. Affichage de {name} à la place.",
  "forecastMaps.contourLevels": "Niveaux de contour",
  "forecastMaps.countryCanada": "Canada",
  "forecastMaps.countryFrance": "France",
  "forecastMaps.countryGermany": "Allemagne",
  "forecastMaps.countryItaly": "Italie",
  "forecastMaps.countryScandinavia": "Scandinavie",
  "forecastMaps.countrySpain": "Espagne",
  "forecastMaps.countrySwitzerland": "Suisse",
  "forecastMaps.countryUnitedStates": "États-Unis",
  "forecastMaps.coverageUnknown": "Zone inconnue",
  "forecastMaps.coversView": "Couvre {coverage, number, percent} de cette vue",
  "forecastMaps.customColormapMinColors": "Une palette personnalisée nécessite au moins deux couleurs",
  "forecastMaps.customExtent": "Emprise personnalisée",
  "forecastMaps.displayName": "Nom affiché",
  "forecastMaps.downscaling": "Facteur d'espacement des barbules",
  "forecastMaps.dpi": "DPI",
  "forecastMaps.drawArea": "Dessiner la zone",
  "forecastMaps.east": "Est",
  "forecastMaps.extentDrawHint": "Faites glisser sur la carte pour dessiner la zone",
  "forecastMaps.extentInvalid": "L'ouest doit être inférieur à l'est et le sud inférieur au nord",
  "forecastMaps.frameTime": "Heure de la prévision",
  "forecastMaps.height": "Hauteur (pouces)",
  "forecastMaps.hourOffset": "+{hour} h",
  "forecastMaps.inThisArea": "Dans cette zone",
  "forecastMaps.invalidHexColor": "Couleur invalide — utilisez #RRGGBB",
  "forecastMaps.layerHasErrors": "Cette couche contient des erreurs",
  "forecastMaps.layers": "Couches",
  "forecastMaps.layerTypeBarbs": "Barbules de vent",
  "forecastMaps.layerTypeContour": "Lignes de contour",
  "forecastMaps.layerTypeFilledContour": "Contours remplis",
  "forecastMaps.layerTypeMagnitude": "Magnitude",
  "forecastMaps.layerTypeRaster": "Raster",
  "forecastMaps.layerTypeVectorField": "Champ de vecteurs",
  "forecastMaps.leave": "Quitter",
  "forecastMaps.levelsCount": "Nombre",
  "forecastMaps.levelsInvalid": "Niveaux de contour invalides",
  "forecastMaps.levelsModeArange": "Pas fixe",
  "forecastMaps.levelsModeExplicit": "Valeurs explicites",
  "forecastMaps.levelsModeLinspace": "Régulièrement espacés (nombre)",
  "forecastMaps.levelsStep": "Pas",
  "forecastMaps.levelsValues": "Valeurs",
  "forecastMaps.levelsValuesHint": "Séparées par des virgules, croissantes",
  "forecastMaps.loadingMaps": "Chargement des cartes…",
  "forecastMaps.localTimeHint": "Affiché dans votre heure locale",
  "forecastMaps.lockedConfig": "{model} est un modèle Premium. Affichage de {fallback} à la place.",
  "forecastMaps.lockedVariable": "{variable}, Premium",
  "forecastMaps.mapDescription": "Description",
  "forecastMaps.mapName": "Nom de la carte",
  "forecastMaps.mapNameRequired": "Saisissez un nom",
  "forecastMaps.mapSettings": "Paramètres de la carte",
  "forecastMaps.maxLayersReached": "Cette carte a atteint le maximum de {max} couches.",
  "forecastMaps.maxValue": "Valeur max",
  "forecastMaps.memoryBudgetExceeded": "La résolution dépasse le budget de rendu — réduisez le DPI ou la hauteur",
  "forecastMaps.memoryBudgetUsage": "Budget de rendu : {percent}%",
  "forecastMaps.metaDescription": "Cartes de prévision animées générées à partir des modèles météo.",
  "forecastMaps.metric": "Mesure",
  "forecastMaps.metricRequired": "Sélectionnez une mesure",
  "forecastMaps.metricUnavailable": "Indisponible pour ce modèle",
  "forecastMaps.minBelowMax": "Le min doit être inférieur au max",
  "forecastMaps.minMaxRequired": "Les valeurs min et max sont requises pour ce type de couche",
  "forecastMaps.minValue": "Valeur min",
  "forecastMaps.modelChipAuto": "Auto · {model}",
  "forecastMaps.modelCoversView": "{model} couvre {coverage, number, percent} de cette vue",
  "forecastMaps.modelNoRun": "Aucun run terminé pour le moment",
  "forecastMaps.modelOption": "{model}, {grid}",
  "forecastMaps.moveLayerDown": "Descendre",
  "forecastMaps.moveLayerUp": "Monter",
  "forecastMaps.nanClipToMin": "Limiter au min",
  "forecastMaps.nanMask": "Masquer",
  "forecastMaps.nanPolicy": "Données manquantes",
  "forecastMaps.nanSkip": "Ignorer",
  "forecastMaps.noCompletedRun": "Cette carte n'a pas encore été générée. Revenez bientôt.",
  "forecastMaps.noLayers": "Aucune couche pour le moment. Ajoutez une couche pour commencer.",
  "forecastMaps.noMapsAvailable": "Aucune carte de prévision n'est disponible pour le moment.",
  "forecastMaps.north": "Nord",
  "forecastMaps.opacity": "Opacité",
  "forecastMaps.openAsAnimation": "Ouvrir en animation",
  "forecastMaps.otherAreas": "Autres zones",
  "forecastMaps.outsideArea": "Ne couvre pas cette zone",
  "forecastMaps.overlayLegend": "Légende",
  "forecastMaps.pause": "Pause",
  "forecastMaps.play": "Lecture",
  "forecastMaps.pointValueAnnouncement": "{value}, {time}",
  "forecastMaps.pointValueError": "Impossible de charger la prévision pour ce point.",
  "forecastMaps.pointValueLoading": "Chargement de la prévision…",
  "forecastMaps.pointValueUnavailable": "Aucune donnée pour cette heure.",
  "forecastMaps.premiumModelForView": "{model} couvre cette vue",
  "forecastMaps.premiumRequired": "Les cartes de prévision nécessitent Premium",
  "forecastMaps.preview": "Aperçu",
  "forecastMaps.previewEmptyHint": "Configurez au moins une couche valide pour générer un aperçu.",
  "forecastMaps.previewFailed": "L'aperçu a échoué",
  "forecastMaps.previewHour": "Heure de prévision",
  "forecastMaps.previewRendering": "Rendu de l'aperçu…",
  "forecastMaps.projection": "Projection",
  "forecastMaps.projectionLambertConformal": "Lambert conforme",
  "forecastMaps.projectionMercator": "Mercator",
  "forecastMaps.projectionPlateCarree": "Plate carrée",
  "forecastMaps.projectionStereographic": "Stéréographique",
  "forecastMaps.regionEurope": "Europe",
  "forecastMaps.regionNorthAmerica": "Amérique du Nord",
  "forecastMaps.removeColor": "Supprimer la couleur",
  "forecastMaps.removeLayer": "Supprimer la couche",
  "forecastMaps.retry": "Réessayer",
  "forecastMaps.run": "Run : {run}",
  "forecastMaps.runNotDisplayable": "Ce run ne peut pas être affiché sur la carte interactive.",
  "forecastMaps.save": "Enregistrer",
  "forecastMaps.selectExtentOnMap": "Sélectionner la zone sur la carte",
  "forecastMaps.showArea": "Voir la zone",
  "forecastMaps.showAreaOf": "Voir la zone, {model}",
  "forecastMaps.south": "Sud",
  "forecastMaps.switchToModel": "Passer à {model}",
  "forecastMaps.title": "Cartes de prévision",
  "forecastMaps.uMetric": "Composante U",
  "forecastMaps.unitConversion": "Conversion d'unités",
  "forecastMaps.unitNone": "Aucune",
  "forecastMaps.unsavedChangesBody": "Vous avez des modifications non enregistrées. Quitter et les abandonner ?",
  "forecastMaps.unsavedChangesTitle": "Modifications non enregistrées",
  "forecastMaps.useCurrentView": "Utiliser la vue actuelle",
  "forecastMaps.useModelDomain": "Désactivé : le domaine complet du modèle est utilisé",
  "forecastMaps.utcTime": "UTC : {time}",
  "forecastMaps.uvMetricsDiffer": "Les mesures U et V doivent être différentes",
  "forecastMaps.valueBetween": "Doit être compris entre {min} et {max}",
  "forecastMaps.variable": "Variable",
  "forecastMaps.variableMissing": "{variable} non disponible",
  "forecastMaps.variableOnlyFrom": "{variable} : disponible uniquement avec {model}",
  "forecastMaps.viewMap": "Voir la carte",
  "forecastMaps.vMetric": "Composante V",
  "forecastMaps.west": "Ouest",
  "forecastMaps.windAnimation": "Animation du vent",
  "forecastModels.addForecastModel": "Ajouter un modèle",
  "forecastModels.atYourStations": "Disponibles à vos stations",
  "forecastModels.comparisonLoadError": "Impossible de charger la comparaison de modèles météo",
  "forecastModels.coverageLoading": "Calcul des stations couvertes par chaque modèle…",
  "forecastModels.description_AROME": "Modèle haute résolution de Météo France à convection résolue couvrant l’Europe occidentale à 1,3 km. Référence pour les prévisions à court terme en France ; actualisé toutes les trois heures.",
  "forecastModels.description_ARPEGE_EU": "Domaine imbriqué européen du modèle ARPEGE de Météo France à 10 km de résolution. Prévisions à moyenne échéance sur l’Europe, actualisées quatre fois par jour.",
  "forecastModels.description_ARPEGE_GLOBAL": "Modèle global de prévision numérique du temps de Météo France à 25 km de résolution, jusqu’à environ 4 jours. Actualisé quatre fois par jour.",
  "forecastModels.description_DMI_DINI": "HARMONIE DINI de DMI : modèle à convection résolue sur le nord-ouest de l'Europe — Danemark, Benelux, Irlande, Royaume-Uni et Scandinavie — 2 km de résolution, jusqu'à 60 heures, actualisé huit fois par jour. Contient des données ouvertes DMI modifiées (CC BY 4.0).",
  "forecastModels.description_EC_GDPS": "Global Deterministic Prediction System (Système global de prévision déterministe) d’Environnement Canada : modèle mondial à moyenne échéance, 15 km de résolution, jusqu’à 10 jours, actualisé deux fois par jour.",
  "forecastModels.description_EC_HRDPS": "Système déterministe de prévision à haute résolution d’Environnement Canada : modèle à convection résolue sur le Canada et le nord des États-Unis, 2,5 km de résolution, jusqu’à 48 heures, actualisé quatre fois par jour.",
  "forecastModels.description_EC_RDPS": "Système régional déterministe de prévision d’Environnement Canada : modèle à moyenne échéance sur l’Amérique du Nord à 10 km de résolution, actualisé quatre fois par jour.",
  "forecastModels.description_ECMWF_HRES": "Le modèle haute résolution (IFS) du Centre européen pour les prévisions météorologiques à moyen terme, largement considéré comme le meilleur système de prévision mondial. Couvre l'ensemble de la planète à une résolution de 25 km jusqu'à 15 jours, mis à jour quatre fois par jour. Contient des données ouvertes ECMWF modifiées (CC BY 4.0).",
  "forecastModels.description_GFS": "Modèle global de référence à moyenne échéance de la NOAA. Couvre toute la planète à 25 km de résolution jusqu’à 16 jours, actualisé quatre fois par jour.",
  "forecastModels.description_HRRR_CONUS": "High-Resolution Rapid Refresh de la NOAA : modèle à convection résolue sur les États-Unis continentaux à 3 km de résolution, actualisé toutes les heures. Idéal pour les prévisions à très court terme des orages et de la météo violente.",
  "forecastModels.description_ICON": "Le modèle global ICON du DWD à une résolution de 13 km couvrant l'ensemble de la planète jusqu'à 7,5 jours, actualisé quatre fois par jour. Datenbasis: Deutscher Wetterdienst.",
  "forecastModels.description_ICON_2I": "ICON-2I d'ItaliaMeteo, opéré avec ARPAE : modèle à convection résolue sur l'Italie — 2,2 km de résolution, jusqu'à 72 heures, actualisé deux fois par jour. Contient des données ouvertes ItaliaMeteo (CC BY 4.0).",
  "forecastModels.description_ICON_CH1": "Run de contrôle ICON-CH1-EPS de MeteoSwiss : modèle à convection résolue sur les Alpes — 1 km de résolution, jusqu'à 33 heures, actualisé toutes les trois heures.",
  "forecastModels.description_ICON_CH2": "Run de contrôle ICON-CH2-EPS de MeteoSwiss : modèle à convection résolue sur les Alpes — Suisse et région alpine environnante — 2,1 km de résolution, jusqu'à 120 heures, actualisé quatre fois par jour.",
  "forecastModels.description_ICON_DE": "Modèle haute résolution de DWD à convection résolue sur l’Allemagne et les pays voisins à 2,2 km de résolution. Prévisions à court terme actualisées deux fois par jour. Datenbasis: Deutscher Wetterdienst.",
  "forecastModels.description_ICON_EU": "Domaine imbriqué européen du modèle ICON de DWD à 7 km de résolution couvrant l’Europe et l’Atlantique nord. Prévisions à moyenne échéance actualisées quatre fois par jour. Datenbasis: Deutscher Wetterdienst.",
  "forecastModels.description_MET_NORWAY": "Service de prévision météo ouvert de l’Institut météorologique norvégien, combinant des modèles nordiques haute résolution et les données ECMWF pour fournir des prévisions mondiales jusqu’à 10 jours.",
  "forecastModels.description_MF_AROME_ANTILLES": "Domaine imbriqué d’AROME sur les Antilles françaises (Guadeloupe, Martinique) à 2,5 km de résolution. Prévisions à court terme actualisées quatre fois par jour.",
  "forecastModels.description_MF_AROME_GUYANE": "Domaine imbriqué d’AROME sur la Guyane française à 2,5 km de résolution. Prévisions à court terme actualisées quatre fois par jour.",
  "forecastModels.description_MF_AROME_NOUVELLE_CALEDONIE": "Domaine imbriqué d’AROME sur la Nouvelle-Calédonie à 2,5 km de résolution. Prévisions à court terme actualisées quatre fois par jour.",
  "forecastModels.description_MF_AROME_POLYNESIE": "Domaine imbriqué d’AROME sur la Polynésie française à 2,5 km de résolution. Prévisions à court terme actualisées quatre fois par jour.",
  "forecastModels.description_MF_AROME_REUNION_MAYOTTE": "Domaine imbriqué d’AROME sur la Réunion et Mayotte à 2,5 km de résolution. Prévisions à court terme actualisées quatre fois par jour.",
  "forecastModels.description_RRFS_CONUS": "Le Rapid Refresh Forecast System de la NOAA sur les États-Unis continentaux à 3 km de résolution. Prévisions horaires actualisées huit fois par jour, jusqu'à 84 heures pour les quatre passages principaux et 18 heures pour les autres.",
  "forecastModels.description_RRFS_NORTH_AMERICA": "Le Rapid Refresh Forecast System de la NOAA couvrant toute l'Amérique du Nord à 13 km de résolution. Prévisions horaires jusqu'à 84 heures, actualisées quatre fois par jour.",
  "forecastModels.description_SMARTMIXIN_MULTIMODEL": "La prévision phare de SmartMixin. Pour chaque heure à votre position, nous choisissons le meilleur modèle disponible — généralement un modèle régional haute résolution là où il en existe un (AROME en France, ICON-D2 en Allemagne, HRRR aux États-Unis, ARPEGE Europe sur le continent…) et nous nous rabattons sur un modèle global ailleurs — puis nous comblons les manques à partir de sources voisines. Le résultat : une prévision unique et homogène couvrant n’importe quel point du globe jusqu’à 14 jours, automatiquement rafraîchie à chaque mise à jour de l’un des modèles sous-jacents.",
  "forecastModels.description_WEATHERFLOW_FORECAST": "Prévision mondiale propriétaire de Weatherflow combinant plusieurs modèles numériques de prévision avec les observations de son réseau de stations météo Tempest. Horizon mondial de 10 jours.",
  "forecastModels.everywhereElse": "Partout ailleurs",
  "forecastModels.everywhereElseFoot": "Utilisé à toute station que vos modèles préférés ne couvrent pas.",
  "forecastModels.everywhereElsePick": "Choisissez-en un",
  "forecastModels.fallbackBlend": "Mélange SmartMixin",
  "forecastModels.fallbackBlendSub": "Combine plusieurs modèles, chacun là où il est le meilleur.",
  "forecastModels.fallbackEcmwf": "ECMWF",
  "forecastModels.fallbackEcmwfSub": "ECMWF HRES partout où il porte.",
  "forecastModels.fallbackGfs": "GFS",
  "forecastModels.fallbackGfsSub": "Le modèle global de la NOAA. Ce que tous les comptes utilisent aujourd'hui.",
  "forecastModels.fallbackResolution": "Résolution la plus fine",
  "forecastModels.fallbackResolutionSub": "La maille la plus fine disponible à chaque station.",
  "forecastModels.forecastChipLabelWithRun": "{model}, run {run}",
  "forecastModels.forecastChipRunHint": "Appui long pour afficher ou masquer le dernier run",
  "forecastModels.forecastComparisonDescription": "Comparez facilement les données des différents modèles météo disponibles",
  "forecastModels.forecastFollowingPreferences": "Selon vos préférences",
  "forecastModels.forecastLoadError": "Impossible de charger les prévisions",
  "forecastModels.forecastModel": "Modèle de prévision",
  "forecastModels.forecastModelAbout": "À propos de {model}",
  "forecastModels.forecastModelComparison": "Comparaison de modèles météo",
  "forecastModels.forecastModelCoverage": "Couverture",
  "forecastModels.forecastModelDescription": "Description",
  "forecastModels.forecastModels": "Modèles de prévision",
  "forecastModels.forecastModelScopeGlobal": "Mondial",
  "forecastModels.forecastModelScopeGlobalDescription": "Ce modèle couvre l’ensemble de la planète.",
  "forecastModels.forecastModelScopeRegional": "Régional",
  "forecastModels.forecastModelScopeRegionalDescription": "Ce modèle ne couvre qu’une région spécifique.",
  "forecastModels.forecastModelSpecifications": "Spécifications",
  "forecastModels.forecastNoPinLocation": "Aucun modèle préféré ne couvre cette localisation — « partout ailleurs » décide.",
  "forecastModels.forecastNoPinStation": "Aucun modèle préféré ne couvre cette station — « partout ailleurs » décide.",
  "forecastModels.forecastNoPreferredModels": "Aucun modèle préféré défini pour l’instant.",
  "forecastModels.forecastOverrideElsewhere": "Vos préférences s’appliquent partout ailleurs.",
  "forecastModels.forecastPickForLocation": "Ou choisissez-en un pour cette localisation",
  "forecastModels.forecastPickForStation": "Ou choisissez-en un pour cette station",
  "forecastModels.forecastPinWinsLocation": "{model} — votre premier modèle préféré qui couvre cette localisation.",
  "forecastModels.forecastPinWinsStation": "{model} — votre premier modèle préféré qui couvre cette station.",
  "forecastModels.forecastServedNowHere": "Pour l’instant c’est {model} ici",
  "forecastModels.forecastSetForLocation": "Défini pour cette localisation",
  "forecastModels.forecastSetForStation": "Défini pour cette station",
  "forecastModels.forecastSettingsRowSub": "Modèles préférés, et ce qui s’applique partout ailleurs",
  "forecastModels.forecastStopUsingHere": "Ne plus utiliser ici",
  "forecastModels.forecastUseForLocation": "Utiliser {model} pour cette localisation",
  "forecastModels.forecastUseForStation": "Utiliser {model} pour cette station",
  "forecastModels.forecastUsePreferred": "Utiliser mes modèles préférés",
  "forecastModels.frequencyHourly": "Toutes les heures",
  "forecastModels.horizon": "Horizon",
  "forecastModels.horizonValue": "jusqu'à {value} heures",
  "forecastModels.meshSize": "Taille de la grille",
  "forecastModels.pickerShowAll": "Afficher tout le catalogue",
  "forecastModels.pickerUnreachable": "{count, plural, one {# modèle de plus ne couvre} other {# modèles de plus ne couvrent}} aucune de vos stations",
  "forecastModels.pinInUse": "Utilisé",
  "forecastModels.pinShadowed": "Jamais utilisé — un modèle au-dessus couvre toutes vos stations",
  "forecastModels.pinSlots": "{used} sur {max} · choisissez un modèle",
  "forecastModels.pinSlotsFull": "{max, plural, one {Le seul emplacement est utilisé. Retirez son modèle pour en ajouter un autre.} other {Les # emplacements sont utilisés. Retirez-en un pour en ajouter un autre.}}",
  "forecastModels.pinsUncoveredCount": "{used} de vos {count, plural, one {# station} other {# stations}} : aucun modèle préféré ne {used, plural, one {la} other {les}} couvre — « partout ailleurs » décide.",
  "forecastModels.pinsUncoveredNamed": "{stations} : aucun modèle préféré ne {count, plural, one {la} other {les}} couvre — « partout ailleurs » décide.",
  "forecastModels.pinUnreachable": "Jamais utilisé — il ne couvre aucune de vos stations",
  "forecastModels.pinUsedAt": "Utilisé à {stations}",
  "forecastModels.pinUsedAtAll": "{count, plural, one {Utilisé à votre station} other {Utilisé à vos # stations}}",
  "forecastModels.pinUsedAtSome": "Utilisé à {used} de vos {count, plural, one {# station} other {# stations}}",
  "forecastModels.preferredModels": "Modèles préférés",
  "forecastModels.preferredModelsAll": "Une liste, toutes les stations",
  "forecastModels.preferredModelsOne": "Une liste, partout",
  "forecastModels.publisher": "Éditeur",
  "forecastModels.removePreferredModel": "Retirer {model} de vos modèles préférés",
  "forecastModels.resetForecastPreference": "Réinitialiser",
  "forecastModels.resetForecastPreferenceHint": "Efface vos modèles préférés et revient au réglage SmartMixin par défaut.",
  "forecastModels.servedNowMany": "Actuellement : GFS {count, plural, one {à votre station} other {à vos # stations}}.",
  "forecastModels.servedNowNone": "Actuellement : GFS partout.",
  "forecastModels.title_SMARTMIXIN_MULTIMODEL": "SmartMixin multimodèle",
  "forecastModels.title_WEATHERFLOW_FORECAST": "Prévisions Weatherflow",
  "forecastModels.weatherForecastModels": "Modèles de prévisions météo",
  "helpCenter.articleCount": "{count, plural, one {# article} other {# articles}}",
  "helpCenter.articleNotFound": "Article non trouvé",
  "helpCenter.articleNotFoundDescription": "L'article que vous recherchez n'existe pas.",
  "helpCenter.backToHelpCenter": "Retour au centre d'aide",
  "helpCenter.browseByCategory": "Parcourir par catégorie",
  "helpCenter.categoryNotFound": "Catégorie introuvable",
  "helpCenter.categoryNotFoundDescription": "Cette catégorie n'existe pas ou ne contient aucun article.",
  "helpCenter.contactSupport": "Contacter le support",
  "helpCenter.feedbackHelpsImprove": "Vos commentaires nous aident à améliorer nos articles d'aide.",
  "helpCenter.feedbackReasonNotAnswer": "Il ne répond pas à ma question",
  "helpCenter.feedbackReasonOutdated": "Les informations sont obsolètes",
  "helpCenter.feedbackReasonUnclear": "Les instructions ne sont pas claires",
  "helpCenter.feedbackWhatWentWrong": "Quel était le problème ?",
  "helpCenter.helpCategoryAccount": "Compte",
  "helpCenter.helpCategoryBilling": "Facturation",
  "helpCenter.helpCategoryForecast": "Prévisions",
  "helpCenter.helpCategoryGettingStarted": "Premiers pas",
  "helpCenter.helpCategoryProviders": "Fournisseurs",
  "helpCenter.helpCategoryStations": "Stations",
  "helpCenter.helpCategoryTroubleshooting": "Dépannage",
  "helpCenter.helpCenter": "Centre d'aide",
  "helpCenter.landingDescription": "Trouvez des réponses aux questions fréquentes et apprenez à tirer le meilleur parti de SmartMixin.",
  "helpCenter.linkToSection": "Lien vers cette section",
  "helpCenter.menuItemDescription": "FAQ et guides",
  "helpCenter.minRead": "{minutes} min de lecture",
  "helpCenter.onThisPage": "Sur cette page",
  "helpCenter.platformMobileApp": "Application mobile",
  "helpCenter.platformMobileOnly": "Application mobile uniquement",
  "helpCenter.platformWebApp": "Application web",
  "helpCenter.platformWebOnly": "Application web uniquement",
  "helpCenter.popularArticles": "Articles populaires",
  "helpCenter.relatedArticles": "Articles connexes",
  "helpCenter.searchArticles": "Rechercher des articles...",
  "helpCenter.stillNeedHelp": "Besoin d'aide supplémentaire ?",
  "helpCenter.stillNeedHelpDescription": "Si cet article n'a pas répondu à votre question, je serai ravi de vous aider directement.",
  "helpCenter.supportEmailSubject": "Aide SmartMixin",
  "helpCenter.supportEmailSubjectTopic": "Aide SmartMixin — {topic}",
  "helpCenter.thankYouForFeedback": "Merci pour votre retour !",
  "helpCenter.wasArticleHelpful": "Cet article vous a-t-il été utile ?",
  "intro.locationDescription": "Autorisez l’accès à votre position pour obtenir des prévisions précises adaptées à votre emplacement exact — fini les bulletins météo génériques.",
  "intro.locationTitle": "Des prévisions faites pour vous",
  "intro.notificationDescription": "Activez les notifications pour recevoir des alertes en temps réel sur les changements météo importants — pluie, neige ou conditions extrêmes, au bon moment.",
  "intro.notificationsTitle": "Ne ratez aucun changement météo",
  "intro.readyDescription": "Profitez de prévisions précises, d’observations en direct et de données de stations du monde entier — le tout dans une seule application.",
  "intro.readyTitle": "C’est parti !",
  "intro.welcomeDescription": "Recevez des prévisions hyperlocales issues des meilleures agences météo — et accédez à plus de 40 000 stations dans le monde pour consulter les conditions réelles, passées et présentes.",
  "intro.welcomeTitle": "La météo, réinventée pour vous",
  "landing.alsoAvailableOn": "Également disponible sur :",
  "landing.featureAlertsDescription": "Définissez des seuils personnalisés pour n'importe quelle mesure. Soyez alerté quand la température chute, la pluie commence ou le vent se lève.",
  "landing.featureAlertsTitle": "Alertes intelligentes",
  "landing.featureAnalyticsDescription": "Graphiques interactifs, analyse des tendances et statistiques détaillées. Explorez en profondeur les données de température, humidité, pression, pluie et vent.",
  "landing.featureAnalyticsTitle": "Analyses avancées",
  "landing.featureExportDescription": "Recevez toutes vos données météo par e-mail dans un classeur Excel, prêt pour une analyse approfondie dans Excel, Google Sheets ou vos outils préférés.",
  "landing.featureExportTitle": "Exportez vos données",
  "landing.featureForecastDescription": "Accédez à {count, plural, one {#+ modèle de prévision professionnel} other {#+ modèles de prévision professionnels}}, dont ECMWF, GFS et des modèles régionaux. Comparez-les côte à côte pour faire vos propres prédictions.",
  "landing.featureForecastTitle": "Comparez les modèles de prévisions",
  "landing.featureHistoryDescription": "Accédez aux données historiques avec une échelle horaire, journalière et mensuelle. Exportez-les vers Excel pour la recherche ou vos archives personnelles.",
  "landing.featureHistoryTitle": "Historique complet",
  "landing.featureMultiBrandDescription": "Connectez Netatmo, Davis, Tempest, Ecowitt, Ambient Weather et plus encore. Fini de jongler entre les applications.",
  "landing.featureMultiBrandTitle": "Toutes les marques, une seule app",
  "landing.featuresSubtitle": "SmartMixin vous donne les outils pour analyser, comparer et comprendre vos données météo comme un pro.",
  "landing.featuresTitle": "Conçu pour les passionnés de données",
  "landing.finalCtaButton": "Créer un compte gratuit",
  "landing.finalCtaSubtitle": "Rejoignez des milliers de passionnés de météo qui font confiance à SmartMixin.",
  "landing.finalCtaTitle": "Prêt à explorer vos données météo en profondeur ?",
  "landing.heroCta": "Commencer gratuitement",
  "landing.heroDescription": "Analyses poussées, graphiques élégants et prévisions professionnelles — toutes vos stations météo réunies dans une application puissante.",
  "landing.heroSecondaryCta": "Explorer la carte",
  "landing.heroTagline": "Pour les passionnés de météo",
  "landing.heroTitle": "Visualisez votre météo comme jamais",
  "landing.pricingComparisonCaption": "Comparaison des fonctionnalités des offres Gratuit et Premium",
  "landing.pricingFeatureAdvancedMetrics": "Métriques avancées",
  "landing.pricingFeatureAlerts": "Alertes personnalisées",
  "landing.pricingFeatureColumn": "Fonctionnalité",
  "landing.pricingFeatureExport": "Export de données (Excel)",
  "landing.pricingFeatureForecastComparison": "Comparaison des prévisions",
  "landing.pricingFeatureForecasts": "Modèles de prévision",
  "landing.pricingFeatureForecastsFreeTier": "1 modèle",
  "landing.pricingFeatureForecastsPremiumTier": "{count, plural, one {#+ modèle} other {#+ modèles}}",
  "landing.pricingFeatureReports": "Analyses et rapports",
  "landing.pricingFeatureStationComparison": "Comparaison de stations",
  "landing.pricingFeatureWidgets": "Widgets de l'écran d'accueil",
  "landing.pricingFeatureYearOverYear": "Analyse année par année",
  "landing.pricingFreeCta": "Commencer",
  "landing.pricingFreePrice": "0 €",
  "landing.pricingMostPopular": "Le plus populaire",
  "landing.pricingPremiumCta": "Commencer",
  "landing.pricingPremiumDescription": "À partir de 1,99 €/mois — abonnez-vous sur le web, l'App Store ou Google Play",
  "landing.pricingSubtitle": "Commencez gratuitement, passez à Premium quand vous avez besoin de plus.",
  "landing.pricingTitle": "Tarification simple et transparente",
  "landing.statBrands": "Marques supportées",
  "landing.statForecasts": "Modèles de prévision",
  "landing.statStations": "Stations météo",
  "landing.supportedDevicesNote": "Et plus de {count, number} stations publiques du réseau de l’Organisation météorologique mondiale",
  "landing.supportedDevicesSubtitle": "Connectez votre station météo existante en quelques minutes. Nous prenons en charge {count, plural, one {# grande marque} other {# grandes marques}}, et la liste s’allonge.",
  "landing.supportedDevicesTitle": "Compatible avec votre station",
  "metrics.absolutePressure": "Pression absolue",
  "metrics.airDensity": "Densité de l'air",
  "metrics.airGap": "Espace d'air",
  "metrics.apparentTemperature": "Température apparente",
  "metrics.AQI": "AQI",
  "metrics.AQI_24H": "24h AQI",
  "metrics.avg": "Moy.",
  "metrics.avg_wind": "Vent moyen",
  "metrics.beaufort": "Beaufort",
  "metrics.blackGlobeTemperature": "Temp. globe noir",
  "metrics.boilerOn": "Chaudière en marche",
  "metrics.boilerOnInHours": "Chaudière en marche (heures)",
  "metrics.cloudCover": "Nébulosité",
  "metrics.co2": "CO2",
  "metrics.conductivity": "Conductivité",
  "metrics.dailyPrecipitation": "Précipitations journalières",
  "metrics.dailyRain": "Pluie du jour",
  "metrics.degreeDayShort": "DJU",
  "metrics.depth": "Profondeur",
  "metrics.depthSensors": "Capteurs de profondeur",
  "metrics.dewPoint": "Point de rosée",
  "metrics.distance": "Distance",
  "metrics.downTrend": "Tendance à la baisse",
  "metrics.ET": "Évapotranspiration",
  "metrics.etToday": "ET aujourd’hui",
  "metrics.feelsLike": "Ressenti",
  "metrics.feelsLikeWithFormula": "Ressenti ({formula})",
  "metrics.frostPoint": "Point de givre",
  "metrics.gust": "Rafale",
  "metrics.gustDirection": "Direction de la rafale",
  "metrics.hail": "Grêle",
  "metrics.heatIndex": "Indice de chaleur",
  "metrics.heatingDegreeDays": "Degrés-jours de chauffage",
  "metrics.heatingPower": "Puissance de chauffage",
  "metrics.humidex": "Humidex",
  "metrics.humidity": "Humidité",
  "metrics.lastLightningImpact": "Dernier impact de foudre",
  "metrics.lastMeasure": "Dernière mesure",
  "metrics.leafSensors": "Capteurs d'humectation",
  "metrics.leafWetness": "Humectation foliaire",
  "metrics.lightningDistance": "Distance",
  "metrics.lightningStrikeCount": "Nombre d'impacts de foudre",
  "metrics.lightningStrikeDistance": "Distance de l'impact de foudre",
  "metrics.max": "Max.",
  "metrics.max_gust": "Rafale max.",
  "metrics.maxToday": "Max. aujourd'hui",
  "metrics.min": "Min.",
  "metrics.noise": "Bruit",
  "metrics.normalizedHeatingCoefficient": "Coefficient de chauffage normalisé",
  "metrics.outdoorTemperature": "Température extérieure",
  "metrics.PM_1": "PM 1",
  "metrics.PM_10": "PM 10",
  "metrics.PM_2P5": "PM 2,5",
  "metrics.precipitation": "Précipitations",
  "metrics.pressure": "Pression",
  "metrics.rain": "Pluie",
  "metrics.rainDurationValue": "Durée de la pluie : {duration}",
  "metrics.rainfallMeasurement": "Mesure des précipitations",
  "metrics.rainRate": "Intensité de pluie",
  "metrics.relativePressure": "Pression relative",
  "metrics.setPoint": "Consigne",
  "metrics.snow": "Neige",
  "metrics.snowfall": "Chute de neige",
  "metrics.soilMoisture": "Humidité du sol",
  "metrics.soilSensors": "Capteurs de sol",
  "metrics.soilWaterTension": "Tension de l’eau du sol",
  "metrics.solarEnergy": "Énergie solaire",
  "metrics.solarRadiation": "Rayonnement solaire",
  "metrics.speed": "Vitesse",
  "metrics.stableTrend": "Tendance stable",
  "metrics.sum": "Cumul",
  "metrics.temperature": "Température",
  "metrics.temperatureSensors": "Capteurs de température/humidité",
  "metrics.temperatureShort": "Temp.",
  "metrics.thsw": "THSW",
  "metrics.thw": "THW",
  "metrics.upTrend": "Tendance à la hausse",
  "metrics.uv": "UV",
  "metrics.visibility": "Visibilité",
  "metrics.weatherCondition": "Condition météo",
  "metrics.wetBulbGlobeTemperature": "Temp. thermomètre-globe mouillé",
  "metrics.wetBulbTemperature": "Temp. bulbe humide",
  "metrics.wind": "Vent",
  "metrics.windChill": "Refroidissement éolien",
  "metrics.windDirection": "Direction du vent",
  "metrics.windMeasurement": "Mesure du vent",
  "metrics.windRun": "Parcours du vent",
  "metrics.windRunDescription": "Le parcours du vent est la distance totale parcourue par le vent sur une période donnée",
  "metrics.windSpeed": "Vitesse du vent",
  "navigation.allFavorites": "Tout afficher",
  "navigation.breadcrumbs": "Fil d’Ariane",
  "navigation.collapseNavigation": "Réduire la navigation",
  "navigation.expandNavigation": "Développer la navigation",
  "navigation.main": "Principale",
  "navigation.mapShort": "Carte",
  "navigation.skipToContent": "Aller au contenu principal",
  "navigation.stationsShort": "Stations",
  "network.cancelError": "Requête annulée",
  "network.connectionError": "Serveur injoignable",
  "network.networkError": "Réseau non disponible",
  "network.serverError": "Un problème est survenu ...",
  "network.timeoutError": "Délai de connexion dépassé",
  "network.unknownError": "Erreur inconnue",
  "premium.alreadyPremium": "Vous avez déjà un compte premium !",
  "premium.bestValue": "Meilleure offre",
  "premium.billingDetailsAndroid": "Essai gratuit : vous ne serez pas facturé si vous annulez au moins 24 heures avant la fin de l'essai. Ensuite, votre abonnement SmartMixin se renouvelle automatiquement, sauf si vous l'annulez au moins 24 heures avant la fin de la période en cours ; vous pouvez l'annuler à tout moment dans les réglages de votre compte Google Play. Chaque renouvellement est facturé au prix affiché sur le bouton ci-dessus. Le paiement est débité de votre compte Google Play à la confirmation de l'achat et au début de chaque période de renouvellement.",
  "premium.billingDetailsIos": "Essai gratuit : vous ne serez pas facturé si vous annulez au moins 24 heures avant la fin de l'essai. Ensuite, votre abonnement SmartMixin se renouvelle automatiquement, sauf si vous l'annulez au moins 24 heures avant la fin de la période en cours ; vous pouvez l'annuler à tout moment dans les réglages de votre compte App Store. Chaque renouvellement est facturé au prix affiché sur le bouton ci-dessus. Le paiement est débité de votre compte App Store à la confirmation de l'achat et au début de chaque période de renouvellement.",
  "premium.freeBannerBody": "Les comptes gratuits reçoivent GFS partout — vos modèles préférés et « partout ailleurs » prennent effet dès votre abonnement.",
  "premium.freeBannerTitle": "Les préférences s'appliquent avec Premium",
  "premium.freeSubscription": "Abonnement offert",
  "premium.freeTrialForPeriod": "Essai gratuit pendant {period, plural, one {# jour} other {# jours}}",
  "premium.getUnlimitedAccess": "Accès illimité à :",
  "premium.manageMySubscription": "Gérer mon abonnement",
  "premium.notPurchasedYet": "Aucun achat SmartMixin Premium n'a été trouvé pour ce compte de la boutique.",
  "premium.orChooseMonthly": "Ou choisir mensuel :",
  "premium.premium": "SmartMixin Premium",
  "premium.premiumActive": "Actif",
  "premium.premiumAnnualTrialInfo": "Commencez avec un essai gratuit de {days, plural, one {# jour} other {# jours}}",
  "premium.premiumCurrentPlan": "Abonnement actuel",
  "premium.premiumDownloadApp": "Téléchargez l'application pour vous abonner :",
  "premium.premiumEndsOn": "Expire le {date}",
  "premium.premiumFeatureAlerts": "Alertes météo",
  "premium.premiumFeatureAnalysis": "Analyse météo avancée",
  "premium.premiumFeatureCharts": "Comparaisons de graphiques",
  "premium.premiumFeatureExport": "Export de données",
  "premium.premiumFeatureForecast": "Modèles de prévisions régionaux",
  "premium.premiumFeatureNotification": "Widget barre d'état",
  "premium.premiumFeatureTitle": "Fonctionnalité Premium",
  "premium.premiumFeatureWidgets": "Widgets de l'écran d'accueil",
  "premium.premiumFreePlan": "Gratuit",
  "premium.premiumInactive": "Non abonné",
  "premium.premiumManageStoreSubscription": "Vous vous êtes abonné via {store}. Gérez ou résiliez votre abonnement depuis cette boutique.",
  "premium.premiumManageWebSubscription": "Gérer votre abonnement, mettre à jour le moyen de paiement ou annuler.",
  "premium.premiumPremiumPlan": "Premium",
  "premium.premiumRenewsOn": "Renouvellement le {date}",
  "premium.premiumSubscribeAnnual": "Annuel — 9,99 €/an",
  "premium.premiumSubscribedOn": "Abonné sur {platform}",
  "premium.premiumSubscribedOnWeb": "Abonné sur le web",
  "premium.premiumSubscribeMonthly": "Mensuel — 1,99 €/mois",
  "premium.premiumSubscribeOnWeb": "Abonnez-vous maintenant pour débloquer toutes les fonctionnalités Premium.",
  "premium.premiumSubscriptionSuccess": "Votre abonnement a été activé ! Profitez de toutes les fonctionnalités Premium.",
  "premium.premiumSubscriptionSuccessTitle": "Bienvenue dans Premium !",
  "premium.premiumWebappNotice": "L'abonnement sur le web n'est pas disponible pour le moment.",
  "premium.pricePerMonth": "{price}/mois",
  "premium.pricePerYear": "{price}/an",
  "premium.purchasedNetatmoPro": "Vous avez précédemment acheté Netatmo Pro ({date}). Il vous donne accès à une partie des fonctionnalités premium. Souscrivez à l'une des offres ci-dessous pour avoir accès à toutes les fonctionnalités premium.",
  "premium.purchaseFailed": "Votre achat n'a pas pu aboutir. Veuillez réessayer.",
  "premium.restoreFailed": "Vos achats n'ont pas pu être restaurés. Veuillez réessayer.",
  "premium.restorePurchase": "Restaurer un achat",
  "premium.savingsPercent": "Économisez {percent}%",
  "premium.seePremium": "Découvrir Premium",
  "premium.startFreeTrial": "Démarrer l'essai gratuit",
  "premium.storeUnavailable": "La boutique n'est pas disponible pour le moment. Veuillez réessayer plus tard.",
  "premium.subscribeNow": "S'abonner maintenant — sans essai",
  "premium.switchToPremium": "Passer à SmartMixin Premium",
  "premium.thenPrice": "puis {price}",
  "providerHints.ambientWeatherApiKey": "Créée dans les paramètres de votre compte ambientweather.net.",
  "providerHints.davisApiSecret": "Affiché une seule fois lors de la création de la clé API V2 — conservez-le précieusement.",
  "providerHints.davisV2ApiKey": "Depuis la page des clés API V2 de weatherlink.com.",
  "providerHints.ecowittApi": "Depuis la page API de votre compte Ecowitt.",
  "providerHints.ecowittApp": "La clé d'application, également dans votre compte Ecowitt.",
  "providerHints.myAcuriteCredentialsBanner": "Utilisez l'e-mail et le mot de passe de votre compte My AcuRite — pas votre identifiant SmartMixin.",
  "providerHints.myAcuriteEmail": "L'adresse e-mail de votre compte My AcuRite — pas votre identifiant SmartMixin.",
  "providerHints.myAcuritePassword": "Le mot de passe de votre compte My AcuRite.",
  "providerHints.weatherflowToken": "Jeton à usage personnel depuis tempestwx.com → paramètres → autorisations des données.",
  "providerHints.wundergroundEditKey": "Utiliser une autre clé",
  "providerHints.wundergroundKey": "Une longue chaîne issue de la page des clés API de votre compte Weather Underground — pas votre mot de passe wunderground.com.",
  "providerHints.wundergroundKeyExample": "ex. 5f6a7b8c9dabcdef…",
  "providerHints.wundergroundKeyVerified": "Clé API vérifiée",
  "providerHints.wundergroundNoStationsNearby": "Aucune station trouvée près de cet emplacement. Essayez de saisir directement un identifiant de station.",
  "providerHints.wundergroundStationIdExample": "ex. KCASANFR123",
  "providerIntro.ambientWeatherStep2": "Récupérez votre clé API Ambient Weather.",
  "providerIntro.davisStep2": "Récupérez votre clé API V2 et votre secret API Davis.",
  "providerIntro.ecowittStep2": "Récupérez votre clé API et votre clé d'application Ecowitt.",
  "providerIntro.getStarted": "Commencer",
  "providerIntro.myAcuriteStep2": "Utilisez l'adresse e-mail et le mot de passe de votre compte My AcuRite.",
  "providerIntro.netatmoEnergyStep2": "Connectez-vous à Netatmo lorsque demandé — aucune clé API nécessaire.",
  "providerIntro.netatmoWeatherStep2": "Connectez-vous à Netatmo lorsque demandé — aucune clé API nécessaire.",
  "providerIntro.signupBanner": "Presque fini — créez votre compte SmartMixin gratuit pour connecter {provider}.",
  "providerIntro.step1": "Connectez-vous à votre compte SmartMixin (PAS à votre compte {provider}).",
  "providerIntro.step3EmailPassword": "Saisissez-les ici.",
  "providerIntro.step3KeyOrToken": "Collez-le ici.",
  "providerIntro.step3OAuth": "Autorisez SmartMixin dans la fenêtre qui s'ouvre.",
  "providerIntro.step3Wunderground": "Collez votre clé API, puis sélectionnez une station à proximité ou saisissez n'importe quel ID de station.",
  "providerIntro.stepOfTotal": "Étape {step} sur {total}",
  "providerIntro.title": "Connecter {provider}",
  "providerIntro.weatherflowStep2": "Récupérez votre jeton Tempest à usage personnel.",
  "providerIntro.wundergroundBrowsePublic": "Pas de station ? Parcourez les stations publiques",
  "providerIntro.wundergroundFindNearby": "Trouver des stations près de moi",
  "providerIntro.wundergroundOrEnterId": "Ou saisir un identifiant de station",
  "providerIntro.wundergroundStep2": "Récupérez votre clé API Weather Underground. Vous pourrez ensuite connecter n'importe quelle station — la vôtre ou une station publique.",
  "reports.agroMeteorology": "Agrométéorologie",
  "reports.analysis": "Analyses",
  "reports.annualCumulativeRainfallComparison": "Comparatif des cumuls annuels des précipitations",
  "reports.annualHeatingDurationComparison": "Comparatif annuel de la durée de chauffe",
  "reports.annualHeatingEfficiency": "Efficacité thermique annuelle",
  "reports.annualIndoorComparison": "Comparatif intérieur annuel",
  "reports.annualOutdoorComparison": "Comparatif extérieur annuel",
  "reports.annualOutdoorReport": "Rapport extérieur annuel",
  "reports.annualReport": "Rapport annuel",
  "reports.annualSolarReport": "Rapport solaire annuel",
  "reports.annualWaterBalance": "Bilan hydrique annuel",
  "reports.annualWaterBalanceCarryOver": "Report {year} ({value})",
  "reports.annualWaterBalanceDescription": "Un bilan hydrique (version simplifiée, seulement la pluie et l'évapotranspiration sont utilisées) permet de gérer la ressource en eau",
  "reports.avgHumidity": "Humidité moyenne",
  "reports.avgMaxTemperature": "Moyenne T°max",
  "reports.avgMetric": "Moyenne – {metric}",
  "reports.avgMinTemperature": "Moyenne T°min",
  "reports.avgPressure": "Pression moyenne",
  "reports.avgTemperature": "Température moyenne",
  "reports.chartsAndTable": "Graphiques et tableau",
  "reports.climateNormalPeriodOfRecord": "Période d'observation ({years, plural, one {# an} other {# ans}})",
  "reports.climateNormals": "Normales climatiques",
  "reports.climateNormalStandardLabel": "Normale standard ({period})",
  "reports.climateTrendPerDecade": "Tendance des températures : {value} par décennie sur {years, plural, one {# an} other {# ans}}",
  "reports.coldestMonthRanking": "{month} le plus froid jamais enregistré",
  "reports.comfortable": "Confortable (45% {lessThan} Humidité ≤ 60%)",
  "reports.cumulativeRainfall": "Cumul des précipitations",
  "reports.cumulativeRainfallDescription": "Suivez le cumul des précipitations sur la période sélectionnée.",
  "reports.dailyMaxRainfall": "Précipitations journalières maximales",
  "reports.dataExport": "Export de données",
  "reports.dataExportXlsxFormatDescription": "Exportez toutes les données de votre station au format Excel (* .xlsx). Une fois que vous avez cliqué sur le bouton, vous recevrez un email avec les données traitées après quelques minutes.",
  "reports.daysOfData": "{days, plural, one {# jour} other {# jours}} de données",
  "reports.daysWithFrost": "Jours avec gelées",
  "reports.daysWithHeavyRain": "Jours de fortes pluies (≥ {threshold})",
  "reports.daysWithoutThaw": "Jours sans dégel",
  "reports.daysWithStrongFrost": "Jours avec fortes gelées",
  "reports.emailSent": "Un email vous a été envoyé",
  "reports.frostDays": "Jours de gel",
  "reports.grasslandTemperatureSum": "Somme des températures de prairies",
  "reports.grasslandTemperatureSumDescription": "Reprise durable de la végétation lorsque la somme atteint {threshold}",
  "reports.growingDegreeDays": "Somme des températures",
  "reports.highPressure": "Anticyclone (Pression ≥ {threshold})",
  "reports.iceDays": "Jours sans dégel",
  "reports.indoorReport": "Rapport intérieur",
  "reports.keyFacts": "Faits principaux",
  "reports.longestDrySpell": "Plus longue période sèche",
  "reports.longestRunOfRainyDays": "Nb de jours consécutifs de pluie",
  "reports.longestRunWithoutRun": "Nb de jours consécutifs sans pluie",
  "reports.longestWetSpell": "Plus longue période pluvieuse",
  "reports.lowPressure": "Dépression (Pression {lessThan} {threshold})",
  "reports.maxHumidity": "Humidité maximale",
  "reports.maxMetric": "Maximum – {metric}",
  "reports.maxPressure": "Pression maximale",
  "reports.maxTemperature": "Température maximale",
  "reports.maxTempGreaterThan": "T°max ≥",
  "reports.maxTempMagnitude24h": "Amplitude maximale (/24H)",
  "reports.minHumidity": "Humidité minimale",
  "reports.minMetric": "Minimum – {metric}",
  "reports.minPressure": "Pression minimale",
  "reports.minTemperature": "Température minimale",
  "reports.minTempMagnitude24h": "Amplitude minimale (/24H)",
  "reports.monthlyAverageCountdown": "{days, plural, one {Encore # jour} other {Encore # jours}} ce mois-ci",
  "reports.monthlyAverageCountdownDetail": "La moyenne du mois et son classement apparaîtront alors.",
  "reports.monthlyAverageRule": "Les moyennes mensuelles et les classements apparaissent dès qu'un mois civil compte {days, plural, one {# jour enregistré} other {# jours enregistrés}}.",
  "reports.monthlyHeatingEfficiency": "Efficacité thermique mensuelle",
  "reports.monthlyOutdoorReport": "Rapport extérieur mensuel",
  "reports.monthlyReport": "Rapport mensuel",
  "reports.monthlySolarReport": "Rapport solaire mensuel",
  "reports.monthlyWindReport": "Rapport de vent mensuel",
  "reports.monthsOfData": "{months, plural, one {# mois} other {# mois}} de données",
  "reports.numberOfDays": "Nombre de jours",
  "reports.onThisDayChartRule": "Le graphique année par année apparaît à partir de {count, plural, one {# année enregistrée} other {# années enregistrées}} pour le {date}.",
  "reports.onThisDayChartSummary": "{years, plural, one {# année} other {# années}} avec température, de {first} à {last}. Record de chaleur {high} en {highYears}, record de froid {low} en {lowYear}. Journée normale de {min} à {max}.",
  "reports.onThisDayCoverage": "{years, plural, one {# année depuis {firstYear}} other {# années depuis {firstYear}}}",
  "reports.onThisDayDataSince": "Cette station a des données depuis le {date}.",
  "reports.onThisDayEveryYear": "Tous les {date} enregistrés",
  "reports.onThisDayGapNoData": "sans données",
  "reports.onThisDayInHistory": "Ce jour dans l'histoire",
  "reports.onThisDayLeaveOk": "Vous pouvez quitter cet écran ; le chargement continue.",
  "reports.onThisDayLoadFailed": "Impossible de charger le {date}. Vérifiez votre connexion et réessayez.",
  "reports.onThisDayNoDataRun": "{start}–{end} · aucune donnée ({count, plural, one {# année} other {# années}})",
  "reports.onThisDayNormal": "Journée normale : de {min} à {max}",
  "reports.onThisDayNoYears": "Aucun {date} complet enregistré pour l'instant",
  "reports.onThisDayNoYearsDetail": "Cette page se remplira à partir du premier {date} entièrement enregistré par la station.",
  "reports.onThisDayNoYearSelected": "Aucune année sélectionnée",
  "reports.onThisDayOneReading": "1 mesure",
  "reports.onThisDayOneReadingSummary": "{year} : {value}, 1 mesure, pluie {rain}",
  "reports.onThisDayOpenRecords": "Ouvrir Records et climat",
  "reports.onThisDayPickHint": "Change le jour affiché",
  "reports.onThisDayPickTitle": "Choisir un jour",
  "reports.onThisDayRain": "Pluie le {date}",
  "reports.onThisDayRainNotMeasured": "non mesurée",
  "reports.onThisDayRainOnlySummary": "{year} : pluie {rain}",
  "reports.onThisDayRainSince": "pluie depuis {year}",
  "reports.onThisDayRainSummary": "Pluie le {date}. Jour le plus pluvieux {value} en {years}.",
  "reports.onThisDayRetry": "Réessayer",
  "reports.onThisDaySingleReading": "{count, plural, one {# année n'a qu'une seule mesure ce jour-là et n'est pas tracée} other {# années n'ont qu'une seule mesure ce jour-là et ne sont pas tracées}}.",
  "reports.onThisDaySlowLoad": "Lecture de {years, plural, one {# année} other {# années}} pour le {date}. La première consultation d'une date peut prendre jusqu'à 20 secondes.",
  "reports.onThisDaySlowLoadGeneric": "Lecture de l'historique de cette station pour le {date}. La première consultation d'une date peut prendre jusqu'à 20 secondes.",
  "reports.onThisDayTied": "ex æquo avec {years}",
  "reports.onThisDayTiedMore": "ex æquo avec {years} +{count}",
  "reports.onThisDayYearSummary": "{year} : minimale {min}, maximale {max}, pluie {rain}",
  "reports.onThisDayYearTied": "{year} ({tied})",
  "reports.outdoorReport": "Rapport extérieur",
  "reports.overviewSection": "Vue d’ensemble",
  "reports.rainfall": "Précipitations",
  "reports.rainyDays": "Jours de pluie",
  "reports.recordClimatologicalDay": "Jour climatologique (06–06 UTC)",
  "reports.recordClimDayBody": "Ici, la pluie est cumulée par jour calendaire, de minuit à minuit à l’heure de la station. Les services météorologiques la cumulent de 06:00 à 06:00 UTC : un orage de part et d’autre de minuit peut donc faire d’un autre jour le plus pluvieux.",
  "reports.recordDailyRain": "Jour le plus pluvieux",
  "reports.recordFromHourlyReadings": "D’après les relevés horaires",
  "reports.recordHigh": "Record de chaleur",
  "reports.recordLow": "Record de froid",
  "reports.recordOfficialBody": "Le service météorologique publie un maximum et un minimum quotidiens pour cette station, relevés sur des thermomètres à maximum et à minimum. Ils saisissent des pointes brèves que les relevés horaires manquent, et remplacent donc les valeurs calculées à partir des relevés horaires.",
  "reports.recordOfficialValue": "Valeur officielle",
  "reports.recordsAndClimatology": "Records et climat",
  "reports.recordSheetTitle": "À propos de ces records",
  "reports.recordsSince": "Records depuis {date}",
  "reports.recordWindGust": "Rafale la plus forte",
  "reports.relativelyWet": "Relativement humide (60 % {lessThan} Humidité ≤ 80 %)",
  "reports.sectionReportCount": "{count, plural, one {# rapport} other {# rapports}}",
  "reports.sendEmail": "Envoyer un e-mail",
  "reports.summerDays": "Jours d'été",
  "reports.tableScrollRegion": "{title}, défilement horizontal",
  "reports.tooDry": "Trop sec (Humidité ≤ 45%)",
  "reports.tooWet": "Trop humide (Humidité {greaterThan} 80%)",
  "reports.tropicalNights": "Nuits tropicales",
  "reports.unlockPremiumSubtitle": "Inclus avec SmartMixin Premium",
  "reports.unlockPremiumTitle": "Débloquez {count, plural, one {# fonctionnalité premium} other {# fonctionnalités premium}}",
  "reports.warmestMonthRanking": "{month} le plus chaud jamais enregistré",
  "reports.waterBalance": "Bilan hydrique",
  "reports.yearsOfData": "{years, plural, one {# an} other {# ans}} de données",
  "reports.yearToDateTemperatureComparison": "Comparaison des températures depuis le début de l'année",
  "sensors.bgtSensors": "Globe noir & WBGT",
  "sensors.cameraFeed": "Caméra",
  "sensors.compareHumidity": "Comparer l'humidité",
  "sensors.compareMoisture": "Comparer l'humidité du sol",
  "sensors.comparePm25": "Comparer les PM2.5",
  "sensors.compareTemperatures": "Comparer les températures",
  "sensors.compareWaterTension": "Comparer la tension de l’eau du sol",
  "sensors.depthByChannel": "Profondeur par canal",
  "sensors.heatStressExtreme": "Stress thermique extrême",
  "sensors.heatStressModerate": "Stress thermique modéré",
  "sensors.heatStressNone": "Pas de stress thermique",
  "sensors.heatStressStrong": "Stress thermique fort",
  "sensors.heatStressVeryStrong": "Stress thermique très fort",
  "sensors.indoorClimate": "Climat intérieur",
  "sensors.indoorCo2Levels": "Niveaux de CO2",
  "sensors.indoorTemperatureAndHumidity": "Température et humidité",
  "sensors.leafWetnessByChannel": "Humidité des feuilles par canal",
  "sensors.lightningSensor": "Foudre",
  "sensors.moistureByChannel": "Humidité du sol par canal",
  "sensors.noDataAvailable": "Aucune donnée disponible",
  "sensors.pm10AndAqi": "PM10 & AQI",
  "sensors.pm1AndAqi": "PM1.0 & AQI",
  "sensors.pm25AndAqi": "PM2.5 & AQI",
  "sensors.pm25ByChannel": "PM2.5 par canal",
  "sensors.pm4AndAqi": "PM4.0 & AQI",
  "sensors.selectChannel": "Sélectionner le canal",
  "sensors.sensorDetailDescription": "Consultez les données historiques et les tendances de vos capteurs.",
  "sensors.sensorHistory": "Historique du capteur",
  "sensors.soilConductivityByChannel": "Conductivité par canal",
  "sensors.soilTemperatureByChannel": "Température du sol par canal",
  "sensors.strikesToday": "Impacts aujourd'hui",
  "sensors.temperatureByChannel": "Température par canal",
  "sensors.viewChart": "Voir le graphique",
  "sensors.waterTensionByChannel": "Tension de l’eau du sol par canal",
  "settings.appearance": "Apparence",
  "settings.appVersion": "SmartMixin v{version}",
  "settings.arabic": "arabe",
  "settings.bulgarian": "bulgare",
  "settings.catalan": "catalan",
  "settings.chartGestures": "Gestes sur les graphiques",
  "settings.chartGesturesDescription": "Faire glisser le doigt sur les graphiques change la période, le pincement des graphiques change l'échelle de temps",
  "settings.choiceCount": "{count, plural, one {# disponible} other {# disponibles}}",
  "settings.contactUs": "Nous contacter",
  "settings.contactUsDescription": "Obtenir de l'aide ou envoyer des commentaires",
  "settings.croatian": "croate",
  "settings.czech": "tchèque",
  "settings.dailyDetailByPeriods": "Détail journalier par moments",
  "settings.dailyDetailByPeriodsDescription": "Regrouper les 24 heures en nuit, matin, après-midi et soirée — le même découpage que la phrase de synthèse du jour.",
  "settings.danish": "danois",
  "settings.dark": "Thème sombre",
  "settings.dataDisplay": "Affichage des données",
  "settings.dateAndTime": "Date et heure",
  "settings.donateButton": "Faire un don",
  "settings.donateDescription": "SmartMixin est développé par une petite équipe. Si l'application vous est utile, vous pouvez soutenir son développement avec un don unique du montant de votre choix. C'est un cadeau — cela ne change pas votre formule et ne débloque aucune fonctionnalité.",
  "settings.donateSuccessBody": "Votre don aide à faire fonctionner SmartMixin et à l'améliorer. Nous vous en sommes très reconnaissants.",
  "settings.donateSuccessTitle": "Merci pour votre soutien !",
  "settings.donateTitle": "Soutenir SmartMixin",
  "settings.dragToReorder": "Glissez pour réordonner",
  "settings.dutch": "néerlandais",
  "settings.english": "anglais",
  "settings.french": "français",
  "settings.german": "allemand",
  "settings.gestures": "Gestes",
  "settings.greek": "grec",
  "settings.hungarian": "hongrois",
  "settings.italian": "italien",
  "settings.japanese": "japonais",
  "settings.korean": "coréen",
  "settings.language": "Langue",
  "settings.languageDescription": "Langue préférée",
  "settings.light": "Thème clair",
  "settings.mapTheme": "Thème de la carte",
  "settings.mapThemeAuto": "Auto",
  "settings.mapThemeDark": "Sombre",
  "settings.mapThemeDescription": "Avec Auto, la carte suit le thème de l'application.",
  "settings.mapThemeLight": "Claire",
  "settings.measurementUnits": "Unités de mesure",
  "settings.netatmoDashboard": "Tableau de bord Netatmo",
  "settings.netatmoLayoutCards": "Liste de cartes",
  "settings.netatmoLayoutCardsDescription": "Une carte par module, tout sur un seul défilement",
  "settings.netatmoLayoutClassic": "Classique",
  "settings.netatmoLayoutClassicDescription": "Deux cartes, balayez entre les modules",
  "settings.netatmoNewLayoutNotice": "Nouvelle disposition : une carte par module.",
  "settings.netatmoSwitchBackToClassic": "Revenir au classique",
  "settings.netatmoSwitchToLayout": "Passer à {layout}",
  "settings.norwegian": "norvégien",
  "settings.notificationsSection": "Notifications",
  "settings.ongoingNotificationEnabled": "Activer la notification permanente",
  "settings.ongoingNotificationMetrics": "Métriques affichées",
  "settings.ongoingNotificationPermissionRequired": "L'autorisation de notification est requise",
  "settings.ongoingNotificationPreviewHint": "Aperçu — activez le widget pour l'afficher",
  "settings.ongoingNotificationStatusBar": "Barre d'état",
  "settings.polish": "polonais",
  "settings.portuguese": "portugais",
  "settings.preferencesSection": "Préférences",
  "settings.privacyPolicy": "Politique de confidentialité",
  "settings.russian": "russe",
  "settings.serbian": "serbe",
  "settings.settings": "Paramètres",
  "settings.settingsPageTitle": "Paramètres - {page}",
  "settings.slovak": "slovaque",
  "settings.smallDecimals": "Petites décimales",
  "settings.smallDecimalsDescription": "Afficher les chiffres décimaux dans une taille plus petite",
  "settings.spanish": "espagnol",
  "settings.statusBarWidget": "Widget barre d'état",
  "settings.statusBarWidgetDescription": "Données météo toujours visibles",
  "settings.subscriptionSection": "Abonnement",
  "settings.supportSection": "Support",
  "settings.swedish": "suédois",
  "settings.systemTheme": "Thème système",
  "settings.termsOfService": "Conditions d'utilisation",
  "settings.themeDarkShort": "Sombre",
  "settings.themeLightShort": "Clair",
  "settings.themeSystemShort": "Système",
  "settings.turkish": "turc",
  "settings.ukrainian": "ukrainien",
  "settings.units": "Unités",
  "settings.unitsDescription": "Unités de mesure affichées dans l'application",
  "settings.update": "Mettre à jour",
  "settings.windDirectionConvention": "Flèche de direction du vent",
  "settings.windDirectionConventionDescription": "Choisir comment les flèches de direction du vent sont affichées",
  "settings.windDirectionMeteorological": "Direction d'origine",
  "settings.windDirectionMeteorologicalDescription": "La flèche indique d'où vient le vent (convention météorologique)",
  "settings.windDirectionOceanographic": "Direction du flux",
  "settings.windDirectionOceanographicDescription": "La flèche indique où le vent souffle (convention océanographique)",
  "stations.addAStation": "Ajouter une station",
  "stations.addToFavorites": "Ajouter aux favoris",
  "stations.addYourOwnStation": "Ajoutez votre station",
  "stations.clearRecentLocations": "Effacer tout",
  "stations.clearSearch": "Effacer la recherche",
  "stations.currentLocation": "Emplacement actuel",
  "stations.customizedStationName": "Nom de station personnalisé",
  "stations.favoriteLocations": "Favoris",
  "stations.favoriteLocationsEmpty": "Vous pouvez ajouter jusqu'à 5 emplacements favoris.",
  "stations.favoriteStations": "Favoris",
  "stations.filterStationDescription": "Ne pas afficher les stations dont les mesures ne sont pas fiables",
  "stations.filterStations": "Filtrer les stations",
  "stations.filterStationSourceDescription": "Sélectionner les fournisseurs de stations que vous souhaitez afficher sur la carte",
  "stations.findStationsNearYou": "Trouver des stations près de chez vous",
  "stations.hiddenStations": "Stations masquées",
  "stations.hiddenStationsDescription": "Vous pouvez dévoiler une station en appuyant sur l'icône 'œil' à côté.",
  "stations.hideStationNamed": "Masquer {station}",
  "stations.lastSeen": "vu {time}",
  "stations.loadingStation": "Chargement de la station…",
  "stations.location": "Localisation",
  "stations.locationAddedToFavorites": "Emplacement ajouté aux favoris",
  "stations.locationNotGranted": "L'autorisation de localisation n'est pas accordée. Veuillez permettre l'accès à votre emplacement dans les paramètres de l'appareil.",
  "stations.locationRemovedFromFavorites": "Emplacement supprimé des favoris",
  "stations.locations": "Localisations",
  "stations.locationUnavailable": "Impossible d'obtenir votre position. Veuillez vérifier les paramètres de l'appareil.",
  "stations.maxFavoriteLocationsReached": "Vous ne pouvez avoir que jusqu'à 5 emplacements favoris. Retirez-en un pour en ajouter un autre.",
  "stations.modifyFavoriteStations": "Modifier les stations préférées",
  "stations.modifyFavoriteStationsDescription": "Vous pouvez réorganiser vos stations préférées en les faisant glisser. Vous pouvez également les supprimer de la liste.",
  "stations.myLocation": "Ma position",
  "stations.nearbyWeatherStations": "Stations météo à proximité",
  "stations.noLocationsFound": "Aucun lieu trouvé",
  "stations.noLongerReported": "N’est plus listée",
  "stations.noLongerReportedBy": "Plus listée par {provider} depuis le {date}",
  "stations.noSearchResults": "Aucun article ne correspond à votre recherche",
  "stations.noStationsFound": "Aucune station trouvée",
  "stations.noWeatherStationYet": "Vous n'avez pas de station météo",
  "stations.recentLocations": "Récents",
  "stations.recentLocationsEmpty": "Votre historique récent est vide.",
  "stations.removeFromFavorites": "Supprimer des favoris",
  "stations.removeStationNamed": "Supprimer {station} des favoris",
  "stations.reorderStationNamed": "Déplacer {station}",
  "stations.searchForLocation": "Rechercher un lieu",
  "stations.searchForWeatherStation": "Rechercher une station météo",
  "stations.searchResults": "Résultats de la recherche",
  "stations.searchResultsEmpty": "Aucun résultat trouvé.",
  "stations.searchResultsFound": "{count, plural, one {# résultat trouvé} other {# résultats trouvés}}",
  "stations.searchStationsDescription": "Entrez une ville, une adresse ou un nom de lieu pour trouver des stations météo à proximité.",
  "stations.searchStationsHint": "Utilisez la barre de recherche ci-dessus pour découvrir des stations météo partout dans le monde.",
  "stations.selectStationForComparison": "Sélectionner une station pour la comparaison",
  "stations.stationAddedToFavorites": "Station ajoutée aux favoris",
  "stations.stationCount": "{count, plural, one {# station} other {# stations}}",
  "stations.stationInformation": "Informations sur la station",
  "stations.stationName": "Nom de la station",
  "stations.stationObservationsDescription": "Afficher les dernières observations des stations météo",
  "stations.stationRemovedFromFavorites": "Station supprimée des favoris",
  "stations.stationsLoading": "Chargement des stations météo",
  "stations.stationsNear": "Stations près de {place}",
  "stations.stationType": "Type de station",
  "stations.statusOffline": "Hors ligne",
  "stations.statusOnline": "En ligne",
  "stations.statusStale": "Obsolète",
  "stations.tryAnotherLocation": "Nous n'avons trouvé aucune station météo près de cet emplacement. Essayez de rechercher une autre zone.",
  "stations.unhideStationNamed": "Dévoiler {station}",
  "stations.weatherStation": "Station météo",
  "stations.weatherStationCount": "{count, plural, one {# station météo} other {# stations météo}}",
  "stations.weatherStations": "Stations météo",
  "stations.welcomeConnectService": "Vous possédez une station météo ? Connectez votre service",
  "stations.welcomeSubtitle": "Votre météo, tout au même endroit",
  "thermostat.away": "Absent",
  "thermostat.boilerOn": "En chauffe",
  "thermostat.hg": "Hors-gel",
  "thermostat.homeInformation": "Informations sur la maison",
  "thermostat.homeName": "Nom du domicile",
  "thermostat.manualBoost": "Boost manuel",
  "thermostat.manualSetpointUntil": "Consigne manuelle jusqu'à",
  "thermostat.noThermostatYet": "Vous n'avez pas de thermostat Netatmo",
  "thermostat.relay": "Relai",
  "thermostat.room": "Pièce",
  "thermostat.rooms": "Pièces",
  "thermostat.smartThermostat": "Thermostat intelligent",
  "thermostat.smartValve": "Vanne intelligente",
  "thermostat.whenBackHome": "Quand serez-vous de retour à la maison ?",
  "units.celsius": "Celsius",
  "units.fahrenheit": "Fahrenheit",
  "units.inch": "Pouces",
  "units.inchOfMercury": "Pouces de mercure",
  "units.kelvin": "Kelvin",
  "units.kilometerPerHour": "Kilomètres par heure",
  "units.knot": "Nœuds",
  "units.meterPerSecond": "Mètres par seconde",
  "units.milePerHour": "Miles par heure",
  "units.millibar": "Millibars",
  "units.millimeter": "Millimètres",
  "units.millimeterOfMercury": "Millimètres de mercure",
  "weatherConditions.blizzard": "Blizzard",
  "weatherConditions.blowingDust": "Poussière soulevée",
  "weatherConditions.blowingSnow": "Poudrerie",
  "weatherConditions.breezy": "Brise",
  "weatherConditions.clear": "Ciel dégagé",
  "weatherConditions.cloudy": "Couvert",
  "weatherConditions.drizzle": "Bruine",
  "weatherConditions.flurries": "Neige légère",
  "weatherConditions.foggy": "Brouillard",
  "weatherConditions.freezingDrizzle": "Bruine verglaçante",
  "weatherConditions.freezingRain": "Pluie verglaçante",
  "weatherConditions.frigid": "Froid glacial",
  "weatherConditions.hail": "Grêle",
  "weatherConditions.haze": "Brume sèche",
  "weatherConditions.heavyRain": "Fortes pluies",
  "weatherConditions.heavySnow": "Fortes chutes de neige",
  "weatherConditions.hot": "Chaleur",
  "weatherConditions.hurricane": "Ouragan",
  "weatherConditions.isolatedThunderstorms": "Orages isolés",
  "weatherConditions.mixedRainAndHail": "Pluie et grêle",
  "weatherConditions.mostlyClear": "Ciel plutôt dégagé",
  "weatherConditions.mostlyCloudy": "Très nuageux",
  "weatherConditions.mostlySunny": "Plutôt ensoleillé",
  "weatherConditions.notAvailable": "Conditions météo indisponibles",
  "weatherConditions.partlyCloudy": "Partiellement nuageux",
  "weatherConditions.rain": "Pluie",
  "weatherConditions.rainSleet": "Pluie et grésil",
  "weatherConditions.rainSnow": "Pluie et neige",
  "weatherConditions.scatteredShowers": "Averses éparses",
  "weatherConditions.scatteredSnowShowers": "Averses de neige éparses",
  "weatherConditions.scatteredThunderstorms": "Orages épars",
  "weatherConditions.showers": "Averses",
  "weatherConditions.sleet": "Grésil",
  "weatherConditions.smoke": "Fumée",
  "weatherConditions.snow": "Neige",
  "weatherConditions.snowShowers": "Averses de neige",
  "weatherConditions.strongStorms": "Orages violents",
  "weatherConditions.sunny": "Ensoleillé",
  "weatherConditions.thunderstorms": "Orages",
  "weatherConditions.tornado": "Tornade",
  "weatherConditions.tropicalStorm": "Tempête tropicale",
  "weatherConditions.windy": "Venteux",
  "weatherConditions.wintryMix": "Précipitations hivernales mêlées",
  "weatherMap.clusterMarkerName": "{metric} {value}, médiane de {count, plural, one {# station} other {# stations}}, zoom avant",
  "weatherMap.legendHeavy": "Forte",
  "weatherMap.legendLight": "Légère",
  "weatherMap.legendLightningHelp": "La couleur indique l'âge de chaque impact sur les {minutes} dernières minutes — les plus récents en blanc, les plus anciens en rouge foncé.",
  "weatherMap.legendNewest": "Plus récents",
  "weatherMap.legendOldest": "Plus anciens",
  "weatherMap.legendStationsHelp": "La couleur du marqueur reflète la valeur de la mesure sélectionnée.",
  "weatherMap.lightningDataAttribution": "Données de foudre : Blitzortung.org",
  "weatherMap.lightningStrikes": "Impacts de foudre",
  "weatherMap.lightningStrikesDescription": "Afficher les impacts de foudre en temps réel sur la carte",
  "weatherMap.mapLayers": "Calques de la carte",
  "weatherMap.mapLegend": "Légende de la carte",
  "weatherMap.mapMode": "Mode de la carte",
  "weatherMap.mapNameForecast": "Carte de prévision, {model}, {variable}",
  "weatherMap.mapNameObservations": "Carte météo, observations",
  "weatherMap.modeForecast": "Prévisions",
  "weatherMap.modeObservations": "Observations",
  "weatherMap.radarDataAttribution": "Données radar : NOAA / EUMETNET OPERA via LibreWXR",
  "weatherMap.radarTime": "Heure du radar",
  "weatherMap.rainRadar": "Radar de pluie",
  "weatherMap.rainRadarDescription": "Afficher la superposition du radar de pluie sur la carte",
  "weatherMap.resetBearing": "Faites glisser pour faire pivoter la carte, cliquez pour revenir au nord",
  "weatherMap.showingForecast": "Prévision affichée : {model}, {variable}",
  "weatherMap.signInForecastBody": "Les cartes GFS sont gratuites avec un compte SmartMixin. D’autres modèles sont disponibles avec Premium.",
  "weatherMap.signInForecastTitle": "Connectez-vous pour voir les cartes de prévision",
  "weatherMap.stationMarkerName": "{metric} {value}, une station",
  "weatherMap.stationMarkersHint": "Les touches fléchées passent d’une station à l’autre",
  "weatherMap.stationMarkerWindValue": "{speed}, secteur {direction}",
  "weatherMap.weatherflowNCRain": "NC Rain (Nearcast)",
  "weatherMap.weatherflowNCRainDescription": "NC Rain est une source de données supplémentaire fournie via le système météo Tempest, alimenté par la technologie Nearcast. Les données NC Rain sont une estimation de l'accumulation moyenne de précipitations autour de votre Tempest, à l'échelle du quartier.",
  "weatherMap.weatherMap": "Carte météo",
  "weatherMap.weatherMapMetaDescription": "SmartMixin propose des cartes météo interactives et des radars de pluie pour les conditions météorologiques dans le monde entier.",
  "weatherMap.zoomIn": "Zoom avant",
  "weatherMap.zoomOut": "Zoom arrière",
  "weatherWarnings.activeNow": "En cours",
  "weatherWarnings.agencyMessage": "Message du service météo",
  "weatherWarnings.areaCovered": "Zone concernée",
  "weatherWarnings.areaThisLocation": "{area} (ce lieu)",
  "weatherWarnings.areaYourStation": "{area} (votre station météo)",
  "weatherWarnings.badgeLabel": "{others, plural, =0 {Avertissement officiel, {severity} : {hazard}} one {Avertissement officiel, {severity} : {hazard}, et # de plus} other {Avertissement officiel, {severity} : {hazard}, et # de plus}}",
  "weatherWarnings.badgeLabelUpcoming": "{others, plural, =0 {Avertissement officiel à venir, {severity} : {hazard}} one {Avertissement officiel à venir, {severity} : {hazard}, et # de plus} other {Avertissement officiel à venir, {severity} : {hazard}, et # de plus}}",
  "weatherWarnings.crumb": "Avertissements officiels",
  "weatherWarnings.emptyBody": "Le service météorologique national n’a émis aucun avertissement en vigueur pour ce lieu. Nous vérifions de nouveau régulièrement.",
  "weatherWarnings.emptyTitle": "Aucun avertissement officiel",
  "weatherWarnings.ended": "Terminé",
  "weatherWarnings.endedAt": "Cet avertissement a pris fin {time}.",
  "weatherWarnings.errorBody": "Vérifiez votre connexion. Nous réessayons régulièrement.",
  "weatherWarnings.errorTitle": "Impossible de charger les avertissements officiels",
  "weatherWarnings.fromTime": "À partir de {time}",
  "weatherWarnings.hazardAirQuality": "Qualité de l'air",
  "weatherWarnings.hazardAvalanche": "Avalanches",
  "weatherWarnings.hazardCoastalEvent": "Risques côtiers",
  "weatherWarnings.hazardFlood": "Inondations",
  "weatherWarnings.hazardFog": "Brouillard",
  "weatherWarnings.hazardForestFire": "Feux de forêt",
  "weatherWarnings.hazardHighTemperature": "Températures élevées",
  "weatherWarnings.hazardLowTemperature": "Basses températures",
  "weatherWarnings.hazardOther": "Autre danger",
  "weatherWarnings.hazardRain": "Pluie",
  "weatherWarnings.hazardSnowIce": "Neige et verglas",
  "weatherWarnings.hazardThunderstorm": "Orages",
  "weatherWarnings.hazardUv": "Rayonnement UV",
  "weatherWarnings.hazardWind": "Vent",
  "weatherWarnings.hideHazards": "Masquer les phénomènes",
  "weatherWarnings.issuedBy": "Émis par {sender}",
  "weatherWarnings.lastUpdate": "Dernière mise à jour : {time}",
  "weatherWarnings.mapLabel": "{count, plural, =1 {Carte de la zone concernée : {area}.} other {Carte des # zones concernées. {area} est mise en évidence.}}",
  "weatherWarnings.mapLabelNoHighlight": "{count, plural, =1 {Carte de la zone concernée.} other {Carte des # zones concernées.}}",
  "weatherWarnings.mapUnavailable": "{count, plural, =1 {Carte indisponible. La zone est indiquée ci-dessous.} other {Carte indisponible. Les # zones sont indiquées ci-dessous.}}",
  "weatherWarnings.moreHazards": "+ {count} de plus : {hazards}",
  "weatherWarnings.notInLanguage": "Non disponible en {language}. Affiché tel que publié par le service météo.",
  "weatherWarnings.openOn": "Ouvrir sur {site}",
  "weatherWarnings.otherAreas": "{count, plural, one {+ # autre zone} other {+ # autres zones}}",
  "weatherWarnings.severityExtreme": "Extrême",
  "weatherWarnings.severityFrom": "{severity} à partir de {time}",
  "weatherWarnings.severityMinor": "Mineur",
  "weatherWarnings.severityModerate": "Modéré",
  "weatherWarnings.severityNow": "{severity} maintenant",
  "weatherWarnings.severitySevere": "Sévère",
  "weatherWarnings.severityUntil": "{severity} jusqu’à {time}",
  "weatherWarnings.showAllAreas": "{count, plural, one {Afficher # zone} other {Afficher les # zones}}",
  "weatherWarnings.showAllOnMap": "{count, plural, one {Afficher # zone sur la carte} other {Afficher les # zones sur la carte}}",
  "weatherWarnings.showHazards": "Afficher les phénomènes",
  "weatherWarnings.showPeriods": "{count, plural, one {Afficher # période} other {Afficher les # périodes}}",
  "weatherWarnings.source": "Source : {source}",
  "weatherWarnings.spokenHazardOne": "{hazard} : {status}.",
  "weatherWarnings.spokenHazardTwo": "{hazard} : {first}, puis {second}.",
  "weatherWarnings.spokenLabel": "{count, plural, one {# avertissement météo officiel} other {# avertissements météo officiels}}. {hazards}",
  "weatherWarnings.spokenLabelArea": "{label} {area}.",
  "weatherWarnings.spokenPeriod": "{severity} : {range}",
  "weatherWarnings.title": "Avertissements météo officiels",
  "weatherWarnings.todayAt": "aujourd’hui à {time}",
  "weatherWarnings.tomorrow": "Demain",
  "weatherWarnings.tomorrowAt": "demain à {time}",
  "weatherWarnings.upcoming": "À venir",
  "weatherWarnings.viewAll": "Tous les avertissements officiels",
  "weatherWarnings.whatToDo": "Que faire"
}
